import React from 'react';

const TermsPrivacyFr = () => (
  <div>
    <p>
      <strong>
        CONDITIONS D’UTILISATION ET DÉCLARATION DE CONFIDENTIALITÉ
      </strong>
    </p>
    <p>Date d’entrée en vigueur : 14 novembre 2017</p>
    <p>
      <strong>Introduction</strong>
    </p>
    <p>
      Merci d’utiliser un site Web, une application mobile ou un autre service
      en ligne (le “Service”) qui appartient à et qui est exploitée par Henkel
      Corporation ou à l’une de ses filiales ou sociétés affiliées (“Henkel”,
      “nous”, “notre”, “nos”).
    </p>
    <p>
      Les présentes Conditions d’utilisation (les “Conditions”) ont une
      incidence sur vos droits, responsabilités et obligations juridiques et
      régissent votre utilisation du Service, sont juridiquement contraignantes,
      limitent la responsabilité de Henkel envers vous et exigent que vous nous
      indemnisiez et que, dans certaines régions, certains litiges soient
      résolus à l’aide de l’arbitrage individuel.
    </p>
    <p>
      En visitant ou en utilisant le Service de quelque façon que ce soit, vous
      acceptez les Conditions publiées à ce moment et toutes les Conditions
      supplémentaires applicables (définies plus bas), convenez d’être contraint
      par lesdites Conditions, et que vous les avez lues et comprises. Vous
      reconnaissez et acceptez nos pratiques relatives aux données, décrites
      dans notre{' '}
      <a
        href="https://www.henkel-northamerica.com/privacy-statement-na"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Déclaration de confidentialité
      </a>.
    </p>
    <p>
      Si vous ne souhaitez pas être lié par les présentes Conditions et par
      toute Condition supplémentaire, n’utilisez pas le Service et désinstallez
      les téléchargements et les applications du Service.
    </p>
    <p>
      <strong>Conditions supplémentaires</strong>
    </p>
    <p>
      Dans certains cas, des conditions supplémentaires ou différentes, publiées
      dans le Service, s’appliquent à votre utilisation de certaines parties du
      Service (nommées individuellement et collectivement les “Conditions
      supplémentaires”). Dans la mesure où il existe un conflit entre les
      présentes Conditions et toute Condition supplémentaire, les présentes
      Conditions ont préséance, sauf si les Conditions supplémentaires indiquent
      expressément le contraire.
    </p>
    <p>
      Mises à jour des présentes Conditions et des Conditions supplémentaires
    </p>
    <p>
      Nous pourrions modifier de façon prospective les présentes Conditions et
      les Conditions supplémentaires en publiant des conditions nouvelles ou
      modifiées sur le Service, tel qu’expliqué plus en détail [à la Section
      13].
    </p>

    <h2>Conditions d’utilisation complètes</h2>
    <br />
    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Propriété et exploitation</strong>
        </p>
        <p>
          Le Service et tout son contenu (le “Contenu”), y compris tous les
          droits d’auteur, les brevets, les marques de commerce, les marques de
          service, les raisons sociales et tous les autres droits de propriété
          intellectuelle qui s’y rapportent (la “Propriété intellectuelle”)
          appartiennent à ou sont contrôlés par Henkel, nos concédants et
          certains autres tiers. Tous les droits, titres et intérêts concernant
          le Contenu et la Propriété intellectuelle disponibles à l’aide du
          Service sont la propriété de Henkel, de nos concédants ou de certains
          autres tiers, et sont protégés par des droits d’auteur, des marques de
          commerce, des emballages, des brevets et autres droits de propriété
          intellectuelle et droits contre la concurrence déloyale internationaux
          et des États-Unis dans la plus grande mesure possible. Henkel est
          propriétaire du droit d’auteur relatif à la sélection, à la
          compilation, au regroupement, à l’organisation et à l’amélioration du
          Contenu du Service. Henkel, à sa seule discrétion et sans préavis ou
          responsabilité, pourrait immédiatement suspendre ou interrompre la
          disponibilité du Service et/ou du Contenu (et de tout élément et
          caractéristique qui lui sont associés), en tout ou en partie, pour
          toute raison que ce soit.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Portée géographique prévue</strong>
        </p>
        <p>
          Le Service et son Contenu sont contrôlés à partir des États-Unis
          d’Amérique et du Canada. L’accès au Service à partir de territoires où
          son Contenu est illégal est interdit. Les individus qui choisissent
          d’accéder au Service à partir de l’extérieur des États-Unis ou du
          Canada sont responsables de se conformer à toutes les lois locales qui
          leur sont applicables relativement au Contenu et à l’exploitation du
          Service. Vous êtes responsable de respecter toute la réglementation et
          toutes les lois commerciales applicables, autant nationales
          qu’étrangères. Sauf tel qu’autorisé par les lois américaines et
          canadiennes, vous convenez et garantissez que vous n’exporterez ou ne
          réexporterez pas le logiciel dans tout comté, ou à toute personne,
          toute entité ou tout utilisateur final assujetti à des sanctions ou à
          des mesures de contrôle d’exportation américaines ou canadiennes.
        </p>
        <p>
          Les marques / produits affichés dans le Service sont des exemples de
          marques / produits disponibles de sociétés appartenant à Henkel à
          l’échelle mondiale. Henkel ne garantit pas qu’une marque / un produit
          affiché est aussi disponible dans votre pays.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Confidentialité</strong>
        </p>
        <p>
          En visitant le Service ou en l’utilisant de toute autre façon que ce
          soit, vous acceptez l’<a
            href="https://www.henkel-northamerica.com/privacy-statement-na"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Déclaration de confidentialité
          </a>{' '}
          publié à ce moment-là et consentez aux pratiques relatives aux données
          qui y sont décrites.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Permission limitée d’accéder au Service et de l’utiliser
          </strong>
        </p>
        <p>
          Henkel a pour politique de faire respecter ses droits de Propriété
          intellectuelle dans la plus grande mesure permise par la loi, y
          compris la réclamation de peines criminelles. Votre droit d’utiliser
          le Service et le Contenu est assujetti à votre conformité stricte avec
          les présentes Conditions et les Conditions supplémentaires. Votre
          droit d’accéder au Service et à la Propriété intellectuelle et de les
          utiliser se termine automatiquement à la suite de toute violation.
          Cesdits droits sont non-exclusifs, limités et révocables par nous en
          tout temps à notre seule discrétion sans préavis et sans
          responsabilité de notre part. Étant donné que votre droit d’accès et
          d’utilisation du Service et de son contenu vous appartient
          personnellement, vous ne pouvez pas céder ou transférer votre droit;
          toute tentative de le faire est annulée. Vous pourriez, aux fins
          d’utilisation personnelle, non commerciale et légale seulement
          (collectivement, ce qui suit constitue les “Éléments autorisés par
          Henkel”) :
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Afficher, consulter, utiliser et visionner le Contenu sur un
              ordinateur, un appareil mobile ou un autre appareil connecté à
              Internet (l’”Appareil”) et/ou imprimer une copie du Contenu (à
              l’exception de code source et de code objet en format brut ou
              autrement) tel qu’il s’affiche;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Diffuser en continu le Contenu à l’aide de tout composant
              d’interface et/ou autre lecteur vidéo numérique pour diffusion en
              continu sur Internet, le cas échéant, fourni sur le Service;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Sous réserve de toute Condition supplémentaire applicable, si le
              Service comprend un outil d’”Envoi à un ami” (“Send to Friend”),
              de partage sur les médias sociaux ou autre outil semblable qui
              vous permet de choisir d’envoyer à un ou plusieurs de vos contacts
              une communication qui comprend du contenu, ou de publier notre
              contenu sur des services fournis par des tiers ou sur votre propre
              site ou service en ligne, et que l’outil est fonctionnel,
              utilisez-le pour le faire; à condition, toutefois, que vous le
              fassiez sans violer la loi applicable ou les droits de tiers ou
              sans exprimer de négativité envers nous, et que vous transmettiez
              ledit contenu uniquement à des destinataires que vous êtes
              autorisé à contacter;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Si le Service comprend un lien pour “Télécharger” (“Download”) à
              côté d’un élément de contenu (notamment, une image, une icône, un
              fond d’écran, une piste musicale, une vidéo, une bande-annonce, un
              flux RSS), vous pouvez télécharger une seule copie dudit contenu
              sur un seul Appareil;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Télécharger, installer et utiliser une copie de tout logiciel, y
              compris les applications, que nous rendons disponibles à l’aide du
              Service (les “Logiciels”) sur votre Appareil sous forme de code
              objet exécutable par machine seulement et effectuer une copie
              supplémentaire à des fins de sauvegarde; à condition toutefois que
              vous compreniez et conveniez que i) en vous permettant de
              télécharger le Logiciel, Henkel ne vous transfère aucun titre du
              Logiciel (c.-à-d. que le dispositif que vous utilisez pour
              enregistrer le Logiciel vous appartient, mais que le propriétaire
              du Logiciel [qui pourrait être Henkel et/ou son concédant de
              logiciel tiers] conserve la totalité du titre dudit Logiciel); ii)
              vous n’êtes pas autorisé à copier, à modifier, à adapter, à
              traduire en quelque langue que ce soit, à distribuer ou à créer
              des œuvres dérivées basées sur le Logiciel, sauf tel
              qu’expressément autorisé dans les présentes Conditions ou
              Modalités supplémentaires applicables, sans le consentement écrit
              préalable de Henkel; iii) vous n’êtes pas autorisé à céder, à
              louer ou à prêter le Logiciel à toute personne ou entité et toute
              tentative par vous pour accorder une sous-licence, transférer ou
              céder le Logiciel sera nulle et sans effet; iv) vous n’êtes pas
              autorisé à décompiler, à désassembler, à faire de l’ingénierie
              inverse, ou à tenter de reconstruire, d’identifier ou de découvrir
              tout code source, idées sous-jacentes, techniques d’interface
              d’utilisateur sous-jacentes ou algorithmes du Logiciel par quelque
              moyen que ce soit, sauf dans la mesure où les restrictions
              susmentionnées sont interdites par la loi applicable;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Si cela vous est offert, obtenir un compte personnel enregistré
              (et/ou un nom d’utilisateur et un mot de passe reliés) sur le
              Service et interagir avec le Service subséquemment;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Fournir un lien vers le Service à partir d’un site Web ou d’un
              autre service en ligne, aux conditions suivantes : a) les liens
              comprennent uniquement du texte et n’utilisent aucun nom, logo ou
              image de Henkel, b) les liens et le contenu sur votre site Web ne
              suggèrent aucune affiliation avec Henkel et ne causent aucune
              confusion, et c) les liens et le contenu sur votre site Web ne
              présentent pas Henkel ou ses produits ou services de façon fausse,
              trompeuse, désobligeante ou autrement offensante, et ne
              comprennent pas de contenu illégal, offensant, obscène, lubrique,
              lascif, sale, violent, menaçant, harcelant ou abusif, ou qui viole
              les droits de tout tiers ou est autrement inacceptable pour
              Henkel. Henkel se réserve le droit de suspendre ou d’interdire la
              création de liens vers le Service pour toute raison que ce soit, à
              sa seule discrétion, sans préavis ou toute responsabilité que ce
              soit envers vous ou des tiers;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              L’utilisation de toute autre fonctionnalité fournie expressément
              par Henkel sur le Service ou à l’aide du Service aux fins
              d’utilisation par des utilisateurs, assujettie aux présentes
              Conditions (notamment, la fonctionnalité de créer et/ou de publier
              du Contenu généré par l’utilisateur [tel que défini plus bas]) et
              à toute Condition supplémentaire applicable. Toute utilisation non
              autorisée et tout abus desdites propriétés intellectuelles ou
              desdits travaux sont expressément interdits et constituent une
              violation des lois sur les marques de commerce, des lois sur le
              droit d’auteur, d’autres droits de propriété intellectuelle ou des
              lois sur la concurrence déloyale.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Restrictions relatives au Service et au Contenu</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Restrictions relatives à l’utilisation du Service. Vous convenez
              de ne pas : i) utiliser le Service à des fins politiques ou
              commerciales (notamment, à des fins de publicité, de sollicitation
              de fonds, d’étude du prix des produits et de vente de produits);
              ii) utiliser des métabalises ou tout autre “texte caché” avec une
              Propriété intellectuelle; iii) effectuer des activités en lien
              avec le Service qui ont pour but de tenter de nuire à des
              individus ou à des entités, ou qui sont illégales, offensantes,
              obscènes, lubriques, lascives, sales, violentes, menaçantes,
              harcelantes ou abusives, ou qui violent les droits de tout tiers
              ou sont autrement inacceptables pour Henkel; iv) décompiler,
              désassembler, faire de l’ingénierie inverse, ou tenter de
              reconstruire, d’identifier ou de découvrir tout code source, idées
              sous-jacentes, techniques d’interface d’utilisateur sous-jacentes
              ou algorithmes du Service par quelque moyen que ce soit ou
              modifier tout code source ou code objet du Service ou tout
              Logiciel ou autres produits, services ou processus accessibles
              dans toute partie du Service; v) effectuer toute activité qui nuit
              à l’accès des utilisateurs du Service ou au bon fonctionnement du
              Service, ou qui nuit autrement au Service, à Henkel ou aux autres
              utilisateurs du Service; vi) entraver ou contourner toute
              fonctionnalité de sécurité (y compris les mécanismes ou appareils
              de gestion des droits numériques, ou d’autres mesures de
              protection du contenu ou de contrôle de l’accès) du Service ou de
              toute fonctionnalité qui restreint ou applique les limitations de
              l’utilisation ou de l’accès au Service, au Contenu ou au CGU; vii)
              récolter ou autrement recueillir ou stocker toute information
              (notamment les données personnelles d’autres utilisateurs du
              Service, y compris les adresses courriel, sans le consentement
              explicite desdits utilisateurs); viii) tenter d’accéder sans
              autorisation au Service, à d’autres systèmes ou réseaux
              informatiques connectés au Service, à l’aide d’extraction de mots
              de passe ou par tout autre moyen; ou ix) violer d’une autre façon
              les présentes Conditions ou toute Modalité supplémentaire
              applicable.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Restrictions relatives à l’utilisation du Contenu Vous convenez
              aussi, en utilisant le Service, de : i) ne pas surveiller,
              recueillir, copier ou distribuer le Contenu (sauf à la suite
              d’activités sur des moteurs de recherche courants ou à l’aide de
              l’utilisation d’un navigateur courant) du Service en utilisant
              tout robot, “rover”, agent numérique, robot Web, “scraper”,
              collecteur, logiciel espion, moteur, logiciel, outil d’extraction
              ou tout autre appareil automatique, utilité ou processus manuel de
              quelque nature que ce soit; ii) ne pas tramer ou utiliser des
              techniques de tramage pour isoler ledit contenu (y compris des
              images, du texte ou la disposition de pages); iii) garder intacts
              tous les droits d’auteur, les marques de commerce et autres
              Propriétés intellectuelles et avis faisant partie dudit contenu;
              iv) ne pas utiliser ledit contenu d’une façon qui suggère une
              association non autorisée avec des produits, services ou marques
              nous appartenant ou appartenant à nos concédants; v) ne pas
              apporter de modifications audit contenu (autres que dans la mesure
              précisément permise par nous, le cas échéant); vi) ne pas copier,
              modifier, reproduire, archiver, vendre, louer, échanger, créer des
              œuvres dérivatives, publier sur papier ou par voie électronique,
              présenter publiquement, afficher, disséminer, distribuer,
              diffuser, retransmettre, circuler ou transférer à tout tiers ou
              sur toute application ou tout site Web appartenant à un tiers, ou
              autrement utiliser ou exploiter ledit contenu de quelque façon que
              ce soit, à toute fin que ce soit, sauf tel qu’expressément permis
              par les présentes Conditions ou toute Modalité supplémentaire
              applicable, ou avec le consentement écrit préalable d’un agent de
              Henkel ou, dans le cas de contenu d’un concédant, du propriétaire
              du contenu; et vii) ne pas insérer de code ou de produit pour
              manipuler ledit contenu d’une façon qui nuirait à l’expérience de
              tout utilisateur ou au Service.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Contenu généré par les utilisateurs</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Généralités. Henkel pourrait, maintenant ou dans le futur, offrir
              aux utilisateurs du Service l’occasion de créer, de construire, de
              publier, de télécharger, d’afficher, de publier, de distribuer, de
              transmettre, de diffuser ou de rendre disponible ou de soumettre,
              à l’aide du Service ou sur ou en réponse à nos pages ou
              publications sur toute plateforme de tiers ou en lien avec nos
              promotions sur tout média ou autre, ou de soumettre autrement à
              nous (p. ex. sur notre page Facebook ou sur d’autres pages de
              médias sociaux, en réponse à nos gazouillis, lors de tirages au
              sort ou concours, ou en nous les envoyant d’une autre façon)
              (collectivement, la “soumission”) des messages, du texte, des
              illustrations, des fichiers, des images, des graphiques, des
              photographies, des commentaires, des réponses, des sons, de la
              musique, des vidéos, de l’information, du contenu, des
              évaluations, des analyses, des données, des questions, des
              suggestions, des données personnelles, ou d’autres informations ou
              d’autre matériel et les idées qu’ils contiennent (collectivement
              appelés, à l’exclusion des Éléments autorisés par Henkel décrits
              dans les présentes, le “Contenu généré par l’utilisateur” ou
              “CGU”). Vous pourriez soumettre du CGU à l’aide de votre profil,
              sur des forums, des blogues, des babillards électroniques, des
              environnements de réseautage social, des outils de création et de
              publication de contenu, des jeux, des communautés sociales, les
              outils pour communiquer avec nous, les courriels et d’autres
              fonctionnalités de communication. Sauf dans la mesure des droits
              et des licences que vous accordez en vertu des présentes
              Conditions et, sous réserve des Conditions supplémentaires
              applicables, vous conservez tous les droits, titres et intérêts
              valides sur le plan juridique que vous possédez pour votre CGU.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Non-confidentialité de votre Contenu généré par l’utilisateur. À
              moins d’indications contraires dans l’<a
                href="https://www.henkel-northamerica.com/privacy-statement-na"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Déclaration de confidentialité
              </a>ou toute Conditions supplémentaire applicable, vous convenez
              que a) votre CGU sera traité comme non confidentiel et non
              exclusif par nous, peu importe si vous indiquez qu’il est
              “confidentiel”, “exclusif” et ainsi de suite, et ne vous sera pas
              retourné, et b) dans la portée maximale non interdite par la loi,
              Henkel n’accepte aucune obligation de toute nature que ce soit
              envers vous ou tout tiers concernant votre CGU. Sur demande, vous
              fournirez la documentation nécessaire pour authentifier les droits
              envers ledit contenu et confirmer votre respect des présentes
              Conditions ou de toute Condition supplémentaire applicable. Vous
              reconnaissez que l’Internet et{' '}
              <strong>!Erreur de syntaxe, ^</strong>les communications mobiles
              pourraient être non sécurisés et sujets à des violations de la
              sécurité; par conséquent, vous acceptez que votre CGU soit soumis
              à vos propres risques.
            </p>
            <p>
              Dans vos communications avec Henkel, rappelez-vous que nous ne
              recherchons aucune idée et aucun contenu non sollicité pour des
              produits ou des services, ou même des suggestions pour des
              améliorations des produits ou des services, notamment des idées,
              concepts, inventions ou designs pour de la musique, des sites Web,
              des applications, des livres, des scripts, des pièces de théâtre,
              des films, des émissions de télévision, des productions
              théâtrales, des logiciels ou autres (collectivement appelés “Les
              idées et le matériel non sollicités”, “Idées et matériel non
              sollicités” et “Vos idées et votre matériel non sollicités”).
              Toutes Les idées et le matériel non sollicités que vous soumettez
              sont considérés comme du CGU et la licence nous appartient, tel
              qu’établi ci-dessous. De plus, Henkel possède tous les droits
              détenus par les membres du public concernant toutes Vos idées et
              votre matériel non sollicités. La réception par Henkel de Vos
              idées et votre matériel non sollicités n’est pas une
              reconnaissance par Henkel de leur nouveauté, de leur priorité ou
              de leur originalité, et ne limite pas le droit de Henkel de
              contester les droits de propriété intellectuelle existants ou
              futurs reliés à Vos idées et votre matériel non sollicités.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Licence à Henkel de votre CGU. À l’exception d’indications
              contraires dans toute Condition supplémentaire applicable (comme
              les règles officielles d’une promotion), qui régit précisément la
              soumission de votre CGU, ou dans notre{' '}
              <a
                href="https://www.henkel-northamerica.com/privacy-statement-na"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Déclaration de confidentialité
              </a>, vous accordez par les présentes à Henkel les droits et la
              licence non exclusifs, sans restriction, inconditionnels,
              illimités, mondiaux, irrévocables, perpétuels et gratuits pour
              utiliser, copier, enregistrer, distribuer, reproduire, divulguer,
              vendre, revendre, accorder des sous licences (sur plusieurs
              niveaux), afficher, présenter publiquement, transmettre, publier,
              diffuser, traduire, produire des œuvres dérivées, et autrement
              utiliser et exploiter de quelque manière que ce soit, en totalité
              ou en partie, votre CGU (et les œuvres dérivées de votre CGU), à
              toutes fins que ce soit, dans tout format, par tout moyen ou média
              connu actuellement ou développé dans le futur, et avec toute
              technologie ou appareil connu actuellement ou développé dans le
              futur, et d’annoncer, de commercialiser et promouvoir votre CGU
              (et les œuvres dérivatives de votre CGU. Sans restriction, les
              droits accordés comprennent le droit de : a) configurer, héberger,
              indexer, mettre en mémoire cache, archiver, stocker, numériser,
              compresser, optimiser, modifier, reformater, éditer, adapter,
              publier en format consultable et supprimer lesdits CGU et les
              combiner à d’autre matériel, et b) utiliser tout concept, idée,
              savoir-faire ou technique contenue dans tout CGU à quelque fin que
              ce soit, y compris pour le développement, la production et la
              commercialisation de produits et/ou de services. Vous comprenez
              que dans l’exercice desdits droits, des métadonnées, des avis et
              du contenu pourraient être retirés ou altérés, y compris de
              l’information de gestion du droit d’auteur, et vous consentez par
              les présentes, représentez et garantissez que vous détenez toute
              l’autorité nécessaire pour le faire. Afin de donner davantage
              effet aux droits et à la licence que vous accordez à Henkel
              concernant votre CGU, vous acceptez d’accorder à Henkel, dans la
              mesure où la loi applicable le permet, le droit inconditionnel,
              perpétuel et irrévocable d’utiliser et d’exploiter votre nom,
              votre image et votre apparence en lien avec tout CGU, sans
              qu’aucune obligation ou rémunération ne vous soit due. Sauf
              lorsque la loi l’interdit, vous acceptez de renoncer à tout droit
              moral (y compris l’attribution, l’anonymat et l’intégrité) que
              vous pourriez avoir concernant tout CGU, même s’il est altéré ou
              modifié d’une façon qui ne vous convient pas. Dans la mesure où
              vous ne pouvez pas y renoncer, vous convenez irrévocablement de ne
              pas exercer lesdits droits (le cas échéant) d’une façon qui
              interfère avec l’exercice des droits accordés. Vous comprenez que
              vous ne recevrez aucuns frais, sommes, contrepartie ou
              rémunération pour les droits accordés dans la présente section
              6(c).
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Droit exclusif de Henkel de gérer notre Service. Henkel pourrait,
              sans en avoir l’obligation, examiner, surveiller, afficher,
              publier, stocker, maintenir, accepter ou utiliser d’une autre
              façon votre CGU, en tout ou en partie, et Henkel pourrait, à sa
              seule discrétion, rejeter, effacer, déplacer, reformater,
              supprimer ou refuser de publier ou d’utiliser autrement votre CGU
              sans préavis et sans obligation envers vous ou tout tiers en lien
              avec notre exploitation du CGU de façon appropriée. Sans
              limitation, nous pourrions le faire pour examiner du contenu qui,
              selon nous, est offensant, obscène, lubrique, lascif, sale,
              violent, harcelant, menaçant, abusif, illégal ou autrement
              inacceptable ou inapproprié, ou pour exécuter les droits de tiers,
              les présentes Conditions ou toute Condition supplémentaire
              applicable. Le CGU soumis par vous ou d’autres n’est pas tenu
              d’être maintenu sur le Service par nous pour quelque période que
              ce soit, et vous n’avez pas le droit, après avoir effectué une
              soumission, d’accéder, d’archiver, de maintenir, de modifier, de
              retirer ou d’utiliser d’une autre façon ledit CGU sur le Service
              ou ailleurs, à l’exception des mineurs de la Californie qui
              possèdent certains droits envers certain contenu les concernant
              qu’ils ont publié eux-mêmes sur le Service et retiré
              prospectivement de l’affichage public, tel qu’établi dans l’<a
                href="https://www.henkel-northamerica.com/privacy-statement-na"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Déclaration de confidentialité
              </a>.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Représentations et garanties relatives à votre CGU. Chaque fois
              que vous soumettez du CGU, vous représentez et garantissez que
              vous avez au moins atteint l’âge de la majorité dans la région où
              vous habitez et que vous êtes le parent ou le tuteur légal, ou que
              vous détenez tous les consentements adéquats du parent ou du
              tuteur légal, de tout mineur qui est illustré dans le CGU que vous
              soumettez ou qui y a participé et que, en ce qui a trait audit
              CGU, a) vous êtes l’unique auteur et propriétaire de la propriété
              intellectuelle et des autres droits liés au CGU, ou vous possédez
              le droit légal de soumettre le CGU et accordez à Henkel les droits
              en vertu des présentes Conditions et de toute Condition
              supplémentaire applicable, sans aucune obligation de la part de
              Henkel d’obtenir le consentement d’un tiers et sans créer
              d’obligation ou de responsabilité liant Henkel; b) le CGU est
              exact; c) le CGU n’enfreint pas et, concernant les utilisations et
              l’exploitation de Henkel établis dans les présentes Conditions,
              n’enfreindra aucun droit de propriété intellectuelle ou les droits
              de tout tiers, ou toute loi ou réglementation applicable; et d) le
              CGU ne violera pas les présentes Conditions ou toute Modalité
              supplémentaire applicable, et ne causera pas de préjudice ou de
              dommages à quiconque.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Application. Henkel n’est aucunement tenu de surveiller ou de
              faire appliquer vos droits de propriété intellectuelle à votre
              CGU, mais vous nous donnez le droit de protéger et d’appliquer nos
              droits concernant votre CGU, y compris d’entamer des poursuites en
              votre nom et pour vous (aux frais de Henkel, auxquelles vous
              consentez et nommez irrévocablement Henkel votre fondé de pouvoir,
              doté du pouvoir de substitution et de délégation, dont la
              désignation est accompagnée d’un intérêt).
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Politique de protection du droit d’auteur et agent des droits
            d’auteur en vertu de la Digital Millennium Copyright Act (DMCA)
          </strong>
        </p>
        <p>
          Henkel respecte les droits de propriété intellectuelle d’autrui et
          s’attend à ce que les utilisateurs de son Service fassent de même.
          Henkel pourrait retirer du contenu qui, à sa seule discrétion, semble
          enfreindre les droits de propriété intellectuelle d’autrui. De plus,
          Henkel, à sa seule et absolue discrétion, pourrait fermer les comptes
          des utilisateurs qui enfreignent les droits de propriété
          intellectuelle d’autrui.
        </p>
        <p>
          Si vous croyez qu’un utilisateur du Service a enfreint vos droits
          d’auteur, veuillez aviser l’agent des droits d’auteur de Henkel (voir
          ses coordonnées plus bas) et lui fournir l’information suivante : A)
          la signature physique ou électronique de la personne autorisée à agir
          au nom du propriétaire du droit d’auteur; b) une identification de la
          propriété protégée par le droit d’auteur déclarée comme enfreinte; c)
          une description détaillée du matériel qui, selon vous, est une
          violation, pour que nous puissions le localiser, y compris l’URL où le
          matériel apparaît; d) votre adresse, numéro de téléphone et adresse
          courriel; e) un énoncé par vous déclarant que vous croyez de bonne foi
          que l’utilisation prétendument attentatoire n’est pas autorisée par le
          propriétaire du droit d’auteur, son agent ou la loi; et f) une
          déclaration de votre part, faite sous peine de sanction ou de parjure,
          que l’information qui précède est exacte et que vous êtes autorisé à
          agir au nom du propriétaire des droits d’auteur concernés.
        </p>
        <p>
          Agent des droits d’auteur
          <br />
          Henkel Corporation
          <br />
          One Henkel Way
          <br />
          Rocky Hill, CT 06067
          <br />
          860 571-2661
          <br />
          <a
            href="mailto:CopyrightAgent@henkel.com"
            style={{ textDecoration: 'underline' }}
          >
            CopyrightAgent@henkel.com
          </a>
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Liens et services de tiers</strong>
        </p>
        <p>
          Nous ne sommes pas responsables des tiers ou de leur contenu, de leurs
          publicités, applications ou sites (les “Services offerts par des
          tiers”). Par exemple, des parties du Service pourraient être intégrées
          à des sites, plateformes et applications de tiers ou reliés auxdits
          sites, plateformes et applications, sur lesquels nous n’avons pas de
          contrôle. De même, nous pourrions afficher de la publicité et du
          contenu ou des services de tiers, que nous pourrions aussi ne pas
          contrôler, qui vous sont accessibles à l’aide de notre Service. Cela
          pourrait comprendre la capacité de s’inscrire ou d’ouvrir une session
          dans nos Services à l’aide de Facebook Connect ou d’autres outils de
          tiers, et de publier du contenu sur des sites et des services de tiers
          à l’aide de plugiciels disponibles à l’aide de nos Services. Soyez
          prudent lorsque vous traitez avec des tiers et consultez leurs
          conditions d’utilisation et leurs politiques de confidentialité. Nous
          ne sommes aucunement responsables des Services offerts par des tiers.
          De plus, même si Henkel pourrait vous fournir un lien vers un site Web
          de tiers, il est entendu que Henkel n’endosse, n’approuve, ne
          commandite ou ne soutient pas lesdits sites.
        </p>
        <p>
          Si vous accédez au Service ou l’utilisez à l’aide d’Apple, d’Android
          ou de toute autre plateforme, il s’agit de Services offerts par des
          tiers. Si vous accédez à nos applications sur Apple, cliquez{' '}
          <a
            href="https://www.henkel-northamerica.com/new-content-item/802450"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            ici
          </a>{' '}
          pour connaître les Conditions supplémentaires qui sont applicables
          pour vous et sont intégrées aux Conditions par cette référence.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Exonération de garanties</strong>
        </p>
        <p>
          Nous nous efforçons de décrire avec exactitude nos produits et
          services offerts sur le Service; toutefois, nous ne garantissons pas
          que les spécifications, prix ou autre contenu sur le Service sont
          complets, exacts, fiables, à jour ou sans erreurs et les produits
          pourraient ne pas être disponibles dans toutes les régions. Pour les
          commandes en ligne, le cas échéant, des Conditions supplémentaires
          s’appliquent.
        </p>
        <p>
          TEL QUE PERMIS PAR LA LOI APPLICABLE, LE MATÉRIEL ET L’INFORMATION SUR
          LE SERVICE, ET TOUT MATÉRIEL DISPONIBLE À L’AIDE DU SERVICE, SONT
          FOURNIS “TELS QUELS, TELS QUE DISPONIBLES” ET “AVEC TOUS SES DÉFAUTS”,
          SANS GARANTIE D’AUCUNE SORTE, EXPLICITE OU IMPLICITE. DANS LA PLEINE
          MESURE PERMISE EN VERTU DE LA LOI APPLICABLE, HENKEL ET SES SOCIÉTÉS
          MÈRES DIRECTES ET INDIRECTES, SES FILIALES, SES SOCIÉTÉS AFFILIÉES, ET
          CHACUN DE LEURS EMPLOYÉS, DIRECTEURS, MEMBRES, GESTIONNAIRES,
          ACTIONNAIRES, REPRÉSENTANTS, FOURNISSEURS, CONCÉDANTS, TITULAIRES DE
          LICENCE, ENTREPRENEURS, CLIENTS, SUCCESSEURS ET CESSIONNAIRES
          RESPECTIFS (APPELÉS COLLECTIVEMENT LES “PARTIES DE HENKEL”) SONT
          EXONÉRÉS DE TOUTE GARANTIE EXPLICITE OU IMPLICITE, NOTAMMENT TOUTE
          GARANTIE IMPLICITE DE QUALITÉ MARCHANDE, D’ADAPTATION À UN USAGE
          PARTICULIER, DE TITRE ET DE NON-CONTREFAÇON.
        </p>
        <p>
          TEL QUE PERMIS PAR LA LOI APPLICABLE, LES PARTIES DE HENKEL SONT
          EXONÉRÉES DE TOUTE OBLIGATION ET N’ASSUMENT AUCUNE RESPONSABILITÉ POUR
          LES RÉSULTATS DE TOUT DÉFAUT OU INEXACTITUDE QUI POURRAIT EXISTER DANS
          LE SERVICE OU DÉCOULANT DE SON FONCTIONNEMENT. HENKEL NE GARANTIT
          AUCUNEMENT QUE I) LE FONCTIONNEMENT DU SERVICE RÉPONDRA AUX EXIGENCES
          DES UTILISATEURS; II) L’ACCÈS AU SERVICE SERA ININTERROMPU, SÉCURISÉ,
          EN TEMPS OPPORTUN, EXEMPT DE VIRUS, DE VERS, DE CHEVAUX DE TROIE OU
          D’AUTRES COMPOSANTES DOMMAGEABLES, OU EXEMPT DE DÉFAUTS OU D’ERREURS;
          III) LES RÉSULTATS POUVANT ÊTRE OBTENUS À LA SUITE DE L’UTILISATION DU
          SERVICE SERONT EXACTS OU FIABLES; OU QUE IV) LES DÉFAUTS SERONT
          CORRIGÉS. VOUS (ET NON HENKEL) ASSUMEZ LA TOTALITÉ DES COÛTS DE TOUT
          ENTRETIEN, RÉPARATION OU CORRECTION QUI POURRAIT ÊTRE NÉCESSAIRE POUR
          VOTRE MATÉRIEL INFORMATIQUE ET VOS LOGICIELS À LA SUITE DE TOUT VIRUS,
          ERREUR OU AUTRE PROBLÈME, QUEL QU’IL SOIT, QUE VOUS POURRIEZ AVOIR
          PARCE QUE VOUS AVEZ UTILISÉ LE SERVICE.
        </p>
        <p>
          SANS LIMITER LA PORTÉE DE CE QUI PRÉCÈDE, LA PRÉSENTE SECTION
          N’ACCROÎT PAS ET NE LIMITE PAS I) TOUTE GARANTE DE PRODUIT ÉCRITE
          EXPRESSE OU LES RENONCIATIONS RELIÉES FOURNIES PAR HENKEL OU SES
          FOURNISSEURS CONCERNANT UN PRODUIT PHYSIQUE VENDU PAR HENKEL, OU TOUTE
          GARANTIE POUR UN PRODUIT PHYSIQUE DANS LA MESURE REQUISE PAR LA LOI
          APPLICABLE; II) L’OBLIGATION DES PARTIES DE HENKEL POUR LE PRÉJUDICE
          PERSONNEL QUE LES PARTIES DE HENKEL VOUS ONT CAUSÉ DANS LA MESURE QUI
          N’EST PAS EXONÉRABLE OU QUI NE PEUT PAS ÊTRE LIMITÉE EN VERTU DE LA
          LOI APPLICABLE; OU III) TOUTE CAUSE D’ACTION QUE VOUS POURRIEZ AVOIR À
          L’ENCONTRE DES PARTIES DE HENKEL QUI N’EST PAS EXONÉRABLE OU QUI NE
          PEUT PAS ÊTRE LIMITÉE EN VERTU DE LA LOI APPLICABLE.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Limitation de responsabilité</strong>
        </p>
        <p>
          TEL QUE PERMIS PAR LA LOI APPLICABLE, EN AUCUNE CIRCONSTANCE, QUE CE
          SOIT DÛ À LA NÉGLIGENCE OU AUTRE, LES PARTIES DE HENKEL NE PEUVENT
          ÊTRE TENUES RESPONSABLES DE TOUT DOMMAGE OU PRÉJUDICE, Y COMPRIS LES
          DOMMAGES DIRECTS, INDIRECTS, SPÉCIAUX, ACCESSOIRES, CONSÉCUTIFS,
          PUNITIFS OU AUTRES, NOTAMMENT LA PERTE DE DONNÉES OU DE PROFITS, QUI
          POURRAIENT RÉSULTER DE L’UTILISATION OU DE L’INCAPACITÉ D’UTILISER LE
          SERVICE OU TOUT MATÉRIEL DU SERVICE, DÉCOULANT OU EN LIEN AVEC
          L’UTILISATION OU LA PERFORMANCE DU SERVICE OU DE L’INFORMATION
          DISPONIBLE DANS LE SERVICE. LESDITS DOMMAGES COMPRENNENT NOTAMMENT LES
          DOMMAGES OU LE PRÉJUDICE CAUSÉ PAR DES ERREURS, DES OMISSIONS, DES
          INTERRUPTIONS, DES DÉFAUTS, DES INEXÉCUTIONS, DES RETARDS DE
          FONCTIONNEMENT OU DE TRANSMISSION, DES DÉFECTUOSITÉS DU RÉSEAU OU DES
          VIRUS INFORMATIQUES, VERS, CHEVAUX DE TROIE OU AUTRES COMPOSANTES
          DOMMAGEABLES. Y COMPRIS POUR LES DOMMAGES ACCESSOIRES OU CONSÉCUTIFS.
          TEL QUE PERMIS PAR LA LOI APPLICABLE, EN AUCUN CAS LA RESPONSABILITÉ
          TOTALE DE HENKEL ENVERS VOUS POUR DES DOMMAGES, DES PERTES ET/OU DES
          CAUSES D’ACTION DÉCOULANT DU SERVICE NE PEUT DÉPASSER LE MONTANT LE
          PLUS ÉLEVÉ ENTRE CENT DOLLARS (100 $), OU LE MONTANT QUE VOUS AURIEZ
          VERSÉ À HENKEL EN LIEN AVEC UN PRODUIT OU UN SERVICE SOUTENANT LA
          RÉCLAMATION, ET TOUTE RÉCLAMATION OU CAUSE D’ACTION QUE VOUS POURRIEZ
          AVOIR CONCERNANT LE SERVICE (NOTAMMENT L’ACHAT DE PRODUITS DE HENKEL)
          DOIT ÊTRE ENTAMÉE DANS L’ANNÉE SUIVANT LE FAIT GÉNÉRATEUR DE LA
          RÉCLAMATION OU DE LA CAUSE D’ACTION.
        </p>
        <p>
          SANS LIMITER LA PORTÉE DE CE QUI PRÉCÈDE, LA PRÉSENTE SECTION
          N’ACCROÎT PAS ET NE LIMITE PAS I) TOUTE GARANTIE DE PRODUIT ÉCRITE
          EXPRESSE OU LES RENONCIATIONS CONNEXES FOURNIES PAR HENKEL OU SES
          FOURNISSEURS CONCERNANT UN PRODUIT PHYSIQUE VENDU PAR HENKEL À VOUS,
          OU TOUTE GARANTIE POUR UN PRODUIT PHYSIQUE DANS LA MESURE EXIGÉE PAR
          LA LOI APPLICABLE; II) L’OBLIGATION DES PARTIES DE HENKEL POUR LE
          PRÉJUDICE PERSONNEL QUI VOUS A ÉTÉ CAUSÉ PAR LES PARTIES DE HENKEL
          DANS LA MESURE QUI N’EST PAS EXONÉRABLE OU QUI NE PEUT PAS ÊTRE
          LIMITÉE EN VERTU DE LA LOI APPLICABLE; OU III) TOUTE CAUSE D’ACTION
          QUE VOUS POURRIEZ AVOIR À L’ENCONTRE DES PARTIES DE HENKEL, QUI N’EST
          PAS RENONCIABLE OU QUI NE PEUT PAS ÊTRE LIMITÉE EN VERTU DE LA LOI
          APPLICABLE.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Conditions relatives à l’arbitrage et aux litiges</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Sélection de l’instance/juridiction. Pour les utilisateurs qui ne
              sont pas des résidents de la province de Québec, la juridiction et
              l’instance pour toute controverse, allégation ou réclamation
              découlant du Service, du Contenu, de votre CGU, des présentes
              Conditions, ou de toute Condition supplémentaire applicable
              (collectivement appelées “Litige”) doit avoir lieu à Wilmington,
              Delaware. Chaque partie se soumet à la juridiction personnelle et
              au tribunal de Wilmington, Delaware à toutes les fins possibles.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Avis de préarbitrage. Henkel et vous convenez qu’il serait
              avantageux de discuter et, idéalement, de résoudre tout litige
              avant d’entamer des procédures officielles; à condition,
              toutefois, que Henkel n’ait pas à le faire dans des circonstances
              où ses réclamations relatives aux droits de Propriété
              intellectuelle sont concernées (appelées “Litiges relatifs aux
              droits de Propriété intellectuelle”, alors que tous les autres
              litiges sont appelés “Litiges généraux”). La partie soumettant une
              réclamation - que ce soit vous ou Henkel - doit envoyer une lettre
              à l’autre partie pour résumer brièvement la réclamation et la
              demande de réparation. Si Henkel soumet une réclamation, la lettre
              doit être transmise par courriel à l’adresse courriel figurant
              dans votre compte Henkel, le cas échéant. Si ces renseignements ne
              figurent pas dans votre compte ou s’ils ne sont pas à jour, nous
              ne sommes pas tenus d’envoyer un avis ou de retarder les
              obligations en vertu de la présente section 11(b). Si vous
              soumettez une réclamation, la lettre doit être envoyée à la Henkel
              Corporation, One Henkel Way, Rocky Hill, CT 06067 (À l’attention
              des Services juridiques). Si le Litige n’est pas résolu dans les
              soixante (60) jours suivant l’avis, le demandeur peut entamer des
              procédures, tel qu’établi dans la présente section 11, ou tel que
              permis par la loi applicable. Vous ou Henkel pouvez toutefois
              rechercher des mesures provisionnelles (comme une injonction
              préliminaire, assujettie à la section 11(d)) avant l’expiration de
              la période de soixante (60) jours.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Arbitrage des réclamations. Tel que permis par la loi applicable,
              et pour les utilisateurs qui ne sont pas des résidents individuels
              de la province de Québec, toutes les poursuites ou procédures
              découlant de tout Litige, ou qui y sont reliées, ou la portée des
              dispositions de la présente section, doivent être soumises à JAMS
              (<a
                href="www.jamsadr.com"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                www.jamsadr.com
              </a>{' '}
              - en anglais seulement) pour un arbitrage final et liant en vertu
              de ses Règles et procédures exhaustives d’arbitrage si la question
              en litige dépasse 250 000 $ ou en vertu de ses Règles et
              procédures simplifiées d’arbitrage si la question en litige est de
              250 000 $ ou moins, devant avoir lieu au Delaware devant un seul
              arbitre. L’arbitre sera sélectionné après consentement mutuel des
              parties ou, si les parties ne peuvent pas s’entendre, en
              choisissant dans une liste d’arbitres fournie par JAMS. Nous
              pourrions avoir le droit de payer les frais de JAMS si nécessaire
              pour que l’arbitrage soit exécutable. L’arbitrage est une
              procédure confidentielle, fermée au public; à condition,
              toutefois, qu’une partie puisse divulguer de l’information reliée
              à la procédure d’arbitrage à ses avocats, fournisseurs
              d’assurances, vérificateurs et autres conseillers professionnels
              et à ceux de ses sociétés affiliées. Le fait qu’un litige existe
              entre les parties sujettes à l’arbitrage est confidentiel dans la
              même mesure. L’arbitre doit émettre une opinion écrite énonçant
              les constatations et les conclusions essentielles sur lesquelles
              la décision de l’arbitre est basée. Aucune partie n’a le doit ou
              n’est autorisée à entamer ou à maintenir une poursuite dans une
              cour de justice pour toute question en litige avant que la
              question n’ait été soumise à l’arbitrage, tel que prévu dans les
              présentes, puis uniquement pour l’application de la décision de
              l’arbitre; à condition toutefois qu’avant la nomination de
              l’arbitre ou pour des recours dépassant la compétence de
              l’arbitre, en tout temps, les parties peuvent demander un recours
              pendant l’instance (assujetti aux dispositions des présentes
              Conditions annulant ou limitant ledit recours) dans un tribunal de
              juridiction compétente dans l’État du Delaware ou, sur demande de
              Henkel, un autre tribunal qui pourrait avoir juridiction sur vous,
              sans renoncer à son droit à l’arbitrage du litige ou de la
              controverse en vertu de la présente section; à la condition
              supplémentaire, toutefois, que la partie perdante dispose de
              quinze (15) jours ouvrables après l’émission de la décision de
              l’arbitre pour se conformer complètement à ladite décision, après
              quoi la partie gagnante pourrait exécuter ladite décision à l’aide
              d’une requête aux tribunaux de Wilmington, Delaware ou, dans votre
              cas, à un autre tribunal ayant juridiction sur vous, qui pourrait
              être fait à la demande d’une seule partie, aux fins de
              confirmation et d’application de la décision.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Limitation de l’injonction. TEL QUE PERMIS PAR LA LOI APPLICABLE,
              SI VOUS DÉCLAREZ QUE VOUS AVEZ SUBI DES PERTES, DES DOMMAGES OU UN
              PRÉJUDICE EN LIEN AVEC VOTRE UTILISATION DU SERVICE, LES PERTES,
              LES DOMMAGES ET LE PRÉJUDICE NE SERONT PAS JUGÉS COMME
              IRRÉPARABLES OU SUFFISANTS POUR VOUS DONNER DROIT À UNE INJONCTION
              OU À UNE AUTRE FORME DE RECOURS ÉQUITABLE DE TOUTE NATURE QUE CE
              SOIT. CELA SIGNIFIE (SANS LIMITATION) QUE, EN LIEN AVEC VOTRE
              RÉCLAMATION, VOUS CONVENEZ QUE VOUS NE RECHERCHEREZ, ET QUE VOUS
              N’AUREZ PAS LE DROIT D’OBTENIR, TOUTE POURSUITE EN COUR OU
              AILLEURS QUI POURRAIT ENTRAVER OU EMPÊCHER LE DÉVELOPPEMENT OU
              L’EXPLOITATION DU SERVICE OU DE TOUT ASPECT DE CES DERNIERS, OU DE
              LA PROPRIÉTÉ INTELLECTUELLE DÉTENUE, SOUS LICENCE, UTILISÉE OU
              CONTRÔLÉE PAR TOUTE PARTIE DE HENKEL (Y COMPRIS VOTRE CGU SOUS
              LICENCE) OU À UN CONCÉDANT DE TOUTE PARTIE DE HENKEL.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Droit applicable. Pour les utilisateurs qui ne sont pas des
              résidents individuels de la province de Québec, les présentes
              Conditions et toute Condition supplémentaire applicable, les
              Litiges généraux et les Litiges relatifs aux droits de Propriété
              intellectuelle, et toute autre réclamation soumise par vous à
              l’encontre de Henkel, ou par Henkel à votre encontre en vertu de
              la présente section 11, ou autrement relié au Service, au Contenu,
              aux Éléments autorisés par Henkel, au CGU ou à d’autres produits
              ou services de Henkel, seront régis par les lois de l’État du
              Delaware, États-Unis, sans égard aux dispositions sur les conflits
              des lois qui pourraient appliquer les lois d’une autre
              juridiction. La présente section 11 est régie uniquement par la
              Federal Arbitration Act, 9 U.S.C. §1, et seq., et non par la loi
              de tout État, et est exécutable en vertu de ses modalités sur une
              base automatiquement exécutoire. Vous et Henkel convenez que nous
              entendons que la présente section 11 satisfasse l’exigence
              “écrite” de la Federal Arbitration Act. La présente section 11
              peut uniquement être modifiée d’un commun accord. L’une ou l’autre
              partie peut rechercher l’exécution de la présente section 11 à
              tout tribunal de juridiction compétente. L’arbitre doit déterminer
              toutes les difficultés reliées à l’arbitrabilité d’une
              réclamation.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Exonération des recours collectifs. Dans la mesure où la loi
              applicable le permet, et pour les utilisateurs qui ne sont pas des
              résidents individuels de la province de Québec, vous et Henkel
              renoncez au droit de soumettre tout Litige en tant que recours
              collectif, action réunie, action dérivée ou action générale d’un
              fondé de pouvoir, ou de participer à un recours collectif, à une
              action réunie, à une action dérivée ou à une action générale d’un
              fondé de pouvoir concernant tout Litige soumis par toute autre
              personne. Sans limiter la portée de toute disposition contraire
              des Règles et procédures exhaustives d’arbitrage de JAMS,
              l’arbitre ne détient pas le pouvoir ou la compétence d’entendre
              l’arbitrage de recours collectifs, d’actions réunies, d’actions
              dérivées ou d’actions générales d’un fondé de pouvoir ou de
              regrouper, de joindre ou de combiner autrement les Litiges de
              différentes personnes en une seule poursuite. Sans limiter la
              portée des dispositions d’arbitrage susmentionnées, si la
              disposition relative à la renonciation à un recours collectif, à
              une action réunie, à une action dérivée et à une action générale
              d’un fondé de pouvoir de la présente section 11 est déclarée nulle
              ou autrement inexécutable, tout recours collectif, action réunie,
              action dérivée ou action générale d’un fondé de pouvoir doit être
              entendue et déterminée à l’aide d’une procédure judiciaire
              appropriée, et non par arbitrage.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Renonciation à un jury. TEL QUE PERMIS PAR LA LOI APPLICABLE, LES
              PARTIES RENONCENT PAR LES PRÉSENTES À LEUR DROIT À UN PROCÈS
              DEVANT JURY POUR TOUTES LES RÉCLAMATIONS ET QUESTIONS RELEVANT DES
              PRÉSENTES CONDITIONS OU RELIÉES AUX PRÉSENTES CONDITIONS, LA
              VIOLATION DESDITES CONDITIONS OU LA PORTÉE DES DISPOSITIONS DE LA
              PRÉSENTE SECTION, QUE CE SOIT SUR LE FONDEMENT DU DROIT DES
              CONTRATS OU DE LA RESPONSABILITÉ DÉLICTUELLE, ET Y COMPRIS TOUTE
              RÉCLAMATION POUR INCITATION FRAUDULEUSE DE CES DERNIERS.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Affaires des petites créances. Sans limiter la portée de ce qui
              précède, l’une ou l’autre partie peut soumettre une réclamation
              admissible de Litige général (mais non de Litige relatif aux
              droits de Propriété intellectuelle) aux petites créances, en vertu
              de la section 11(f).
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Préséance. Les dispositions de la présente section 11 ont
              préséance sur toute disposition incohérente de toute entente
              préalable entre les parties. La présente section 11 demeure en
              vigueur indépendamment de toute résiliation de votre utilisation
              du Service ou des présentes Conditions.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Logiciels téléchargés</strong>
        </p>
        <p>
          Si vous téléchargez des logiciels à partir du Service, les logiciels
          et tous les fichiers, images et données reliés aux logiciels sont
          sujets aux conditions de la licence qui accompagnent les logiciels ou
          sont fournies avec les logiciels. Vous pouvez uniquement utiliser les
          logiciels conformément aux conditions desdites licences de logiciels.
          Vous n’êtes pas propriétaire des logiciels téléchargés, et Henkel ne
          vous transfère pas la propriété des logiciels. Vous n’êtes pas
          autorisé à redistribuer, à vendre, à décompiler, à faire de
          l’ingénierie inverse, à désassembler ou à réduire d’une autre façon
          les logiciels sous une forme perceptible par les humains.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Mise à jour des Conditions</strong>
        </p>
        <p>
          Vous êtes responsable de réviser les Conditions publiées et toute
          Condition supplémentaire applicable. Chaque fois que vous utilisez le
          présent SERVICE, VOUS CONCLUEZ UNE NOUVELLE ENTENTE AVEC NOUS EN VERTU
          DES CONDITIONS ET DES MODALITÉS APPLICABLES À CE MOMENT ET VOUS
          CONVENEZ QUE NOUS POUVONS VOUS AVISER DE NOUVELLES CONDITIONS EN LES
          PUBLIANT SUR LE SERVICE (OU PAR TOUT MOYEN RAISONNABLE QUE NOUS
          CHOISISSONS POUR VOUS EN AVISER), ET QUE VOTRE UTILISATION DU SERVICE
          APRÈS UN TEL AVIS CONSTITUE VOTRE ACCORD CONTINU AUX NOUVELLES
          CONDITIONS DANS LE CADRE DE VOTRE UTILISATION ET DE VOS TRANSACTIONS
          FUTURES. Toute nouvelle Condition ou Modalité supplémentaire entrera
          en vigueur pour les nouvelles utilisations et transactions au moment
          où nous la publions, ou à la date ultérieure indiquée dans la nouvelle
          Condition ou Modalité supplémentaire, ou dans un autre avis qui vous a
          été transmis, le cas échéant. Si un avis à votre intention concernant
          des conditions nouvelles, révisées ou supplémentaires est déterminé
          par un tribunal comme étant insuffisant, l’entente antérieure doit se
          poursuivre jusqu’à ce qu’un avis suffisant pour établir une nouvelle
          entente ait été réalisé. Vous pouvez rejeter toute condition nouvelle,
          révisée ou supplémentaire en cessant d’utiliser le Service.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Énoncés prospectifs</strong>
        </p>
        <p>
          Le Service pourrait comprendre des énoncés qui indiquent les
          intentions, les attentes ou les prévisions de Henkel. De tels énoncés
          reflètent les opinions de Henkel à la date de publication des énoncés
          en ce qui a trait aux événements futurs et sont sujets aux risques et
          aux incertitudes. Lesdits énoncés pourraient être inexacts ou devenir
          inexacts à la suite d’événements se produisant après leur date
          respective. Henkel rejette toute intention ou obligation de mettre à
          jour ou de réviser lesdits énoncés.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Divisibilité/absence de renonciation, entente complète
          </strong>
        </p>
        <p>
          Si l’une ou l’autre des dispositions des présentes Conditions s’avère
          illégale, nulle ou inexécutable pour quelque raison que ce soit,
          ladite disposition sera considérée comme divisible des présentes
          Conditions et n’affectera pas la validité et l’exécutabilité des
          autres dispositions. Au cas où Henkel omet d’appliquer les présentes
          Conditions. Cela ne peut constituer une renonciation des droits de
          Henkel en vertu des présentes Conditions, pour des actions passées ou
          futures de la part de toute personne. Les présentes Conditions
          constituent l’entente complète entre Henkel et vous en ce qui a trait
          à l’objet en question, et ont préséance sur toutes les interprétations
          antérieures ou actuelles concernant ledit objet. Aucune modification
          des présentes Conditions ne sera liante, sauf tel qu’indiqué dans une
          mise à jour du présent document par Henkel, ou tel qu’indiqué dans un
          document signé manuellement par un agent autorisé de Henkel.
        </p>
      </li>
    </ol>
    <h2>Déclaration de confidentialité</h2>
    <br />
    <p>
      Merci de visiter un site Web, une application mobile ou un autre service
      en ligne (le “Service”) qui nous appartient et est exploité par la Henkel
      Corporation ou l’une de ses filiales ou sociétés affiliées (“Henkel”,
      “nous”, “notre”, “nos”). Le présent Déclaration de confidentialité décrit
      les renseignements que Henkel pourrait recueillir et comment nous les
      utilisons et les protégeons.
    </p>
    <p>
      Cliquez{' '}
      <a
        href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        ici
      </a>{' '}
      pour consulter nos Conditions d’utilisation. Les résidents de la
      Californie peuvent consulter la section 12A pour prendre connaissance de
      leurs droits en matière de confidentialité.
    </p>
    <p>
      <i>En vigueur à compter du : 14 novembre 2017</i>
    </p>
    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Portée</strong>
        </p>
        <p>
          Le présent Déclaration de confidentialité s’applique à votre
          utilisation de tout Service (p. ex. site Web, application mobile ou
          produit connecté à Internet) qui publie un lien vers le présent
          Déclaration de confidentialité ou fournit autrement un avis de son
          applicabilité, peu importe de quelle façon vous y accédez ou
          l’utilisez. Il ne s’applique pas aux renseignements que nous obtenons
          dans notre capacité à titre d’employeur, sauf pour les demandes
          d’emploi et les requêtes reçues à l’aide du Service. Le présent Énoncé
          de confidentialité s’applique à notre collecte, utilisation et
          divulgation de renseignements à votre sujet à l’aide du Service et ne
          s’applique pas à nos activités hors du Service ou sur des sites Web de
          tiers accessibles par les hyperliens se trouvant sur un Service de
          Henkel.
        </p>
        <p>
          Pour certains aspects du Service, des avis supplémentaires pourraient
          s’appliquer au sujet des pratiques et des choix en matière de
          confidentialité. Veuillez lire lesdites divulgations de
          confidentialité supplémentaires pour comprendre comment elles
          s’appliquent à vous.
        </p>
        <p>
          En utilisant notre Service de quelque façon que ce soit, comme en
          naviguant ou en interagissant, vous signifiez que vous acceptez les
          modalités de notre Déclaration de confidentialité à jour, tel que
          publié ici et des Conditions d’utilisation de notre Service se
          trouvant{' '}
          <a
            href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            ici
          </a>. Si vous ne consentez pas à nos pratiques décrites dans le
          présent Déclaration de confidentialité, vous pouvez et ne devriez pas
          utiliser notre Service.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Révisions</strong>
        </p>
        <p>
          Henkel se réserve le droit de modifier le présent Déclaration de
          confidentialité de manière prospective et les modifications entrent en
          vigueur lors de la publication de l’Déclaration de confidentialité
          révisé; votre utilisation du Service indique que vous consentez à
          l’déclaration de confidentialité publié au moment de l’utilisation.
          Toutefois, nous n’utiliserons pas vos renseignements personnels
          précédemment recueillis par Henkel (définis plus bas), dans la mesure
          où ils ne sont pas recueillis en vertu du nouvel déclaration de
          confidentialité, d’une matière significativement différente que celle
          représentée au moment où ils ont été recueillis sans votre
          consentement. Dans la mesure où une disposition du présent Déclaration
          de confidentialité est déclarée invalide ou inexécutable par un
          tribunal compétent, ladite disposition doit être dissociée dans la
          mesure nécessaire pour que le reste demeure valide et exécutable.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Renseignements recueillis</strong>
        </p>
        <p>
          Vous pouvez visiter notre Service sans nous indiquer qui vous êtes ou
          révéler des renseignements personnels à votre sujet; toutefois, cela
          pourrait rendre certains services de Henkel indisponibles pour vous.
          Vous pouvez toutefois choisir de fournir des Renseignements personnels
          (définis comme des renseignements qui vous identifient
          personnellement, comme votre prénom et votre nom de famille, votre
          adresse courriel, votre numéro de téléphone, votre adresse et votre
          numéro complet de compte de paiement).
        </p>
        <p>
          Les types de renseignements que Henkel peut recueillir à votre sujet
          comprennent notamment :
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'circle' }}>
          <li>
            <p>
              Vos coordonnées (comme votre nom, votre adresse, votre ville,
              votre État, votre province/territoire, votre code ZIP/postal,
              votre adresse courriel et votre numéro de téléphone).
            </p>
          </li>
          <li>
            <p>Préférences en matière de produits.</p>
          </li>
          <li>
            <p>
              Des “Renseignements démographiques” comme la tranche d’âge, le
              sexe, la date de naissance, l’état civil, le code ZIP/postal et la
              composition du ménage). Sauf dans la mesure requise par la loi
              applicable, les Renseignements démographiques sont des
              “Renseignements de nature non personnelle” (c.-à-d. des données
              qui ne sont pas considérées comme des Renseignements personnels en
              vertu du présent Déclaration de confidentialité).
            </p>
          </li>
          <li>
            <p>
              Les “Renseignements sur l’utilisation” comme l’adresse IP,
              l’identifiant de l’appareil, le type de navigateur, le système
              d’exploitation, les renseignements sur votre utilisation du
              Service et les données concernant le matériel connecté au réseau
              (p. ex. l’ordinateur ou d’appareil mobile). Sauf dans la mesure
              exigée par la loi applicable, ou dans la mesure où les
              Renseignements sur l’utilisation sont combinés par Henkel ou au
              nom de Henkel aux Renseignements personnels, Henkel ne considère
              pas les Renseignements sur l’utilisation (notamment les
              identifiants uniques d’appareils) comme des Renseignements
              personnels ou des Renseignements personnels recueillis par Henkel.
            </p>
          </li>
          <li>
            <p>
              Le numéro d’assurance sociale (le “NAS”) (dans des circonstances
              limitées, Henkel pourrait recueillir des NAS, par exemple si vous
              gagnez un tirage au sort ou recevez une rémunération qui doit être
              déclarée à des fins fiscales).
            </p>
          </li>
          <li>
            <p>
              Des photographies et des vidéos (p. ex. qui sont soumises par les
              clients à l’aide de sites Web, par exemple dans le cadre de
              concours ou de tirages au sort).
            </p>
          </li>
          <li>
            <p>
              Les renseignements de demandes d’emploi (comme le NAS, le numéro
              de permis de conduire, des renseignements financiers, la
              vérification des antécédents, et le sexe ou la race [tel que
              permis par la loi]).
            </p>
          </li>
        </ul>
        <p>
          Si vous choisissez de participer aux activités du Service, comme des
          inscriptions sur un site Web, des concours, des tirages au sort, des
          questionnaires, des sondages, des contacts avec le service à la
          clientèle, des achats de produits, des applications mobiles, des
          plateformes de médias sociaux, ou par le biais de notre Centre de
          carrières ou de requêtes sur l’emploi, Henkel recueillera les
          Renseignements personnels que vous fournissez (les “Renseignements
          personnels recueillis par Henkel”). Nous pourrions améliorer ou
          fusionner les renseignements que vous nous fournissez directement avec
          des renseignements provenant d’autres sources, y compris de tiers, aux
          fins décrites plus bas. Dans la mesure où tout renseignement est
          combiné par Henkel ou au nom de Henkel à des Renseignements personnels
          recueillis par Henkel, Henkel traitera les données combinées comme des
          Renseignements personnels recueillis par Henkel en vertu du présent
          Déclaration de confidentialité.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Utilisation des renseignements</strong>
        </p>
        <p>
          Nous recueillerons, maintenons et utilisons vos Renseignements
          personnels recueillis par Henkel, d’autres Renseignements personnels,
          et d’autres renseignements, à des fins qui ne sont pas incompatibles
          avec le présent Déclaration de confidentialité ou tout énoncé écrit
          que nous effectuons au moment de la collecte, par exemple aux fins
          suivantes :
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              établir et vérifier l’identité et l’admissibilité des
              utilisateurs;
            </p>
          </li>
          <li>
            <p>
              télécharger et afficher vos publications et votre contenu
              semblable publié (le “Contenu généré par l’utilisateur” ou “CGU”).
              (Pour en savoir davantage sur la façon dont le CGU est traité en
              vertu des Conditions d’utilisation du Service, cliquez{' '}
              <a
                href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                ici
              </a>{' '}
              [section 6 des Conditions d’utilisation]. Pour en savoir davantage
              sur la nature publique du CGU, voir la section 5);
            </p>
          </li>
          <li>
            <p>
              ouvrir, maintenir, administrer et desservir des profils, des
              comptes ou l’adhésion d’utilisateurs;
            </p>
          </li>
          <li>
            <p>
              traiter, desservir ou effectuer des transactions et envoyer des
              communications connexes;
            </p>
          </li>
          <li>
            <p>
              fournir des produits, des services et du soutien aux utilisateurs;
            </p>
          </li>
          <li>
            <p>
              mettre en œuvre des tirages au sort, des sondages et des concours,
              et fournir les résultats de ces derniers;
            </p>
          </li>
          <li>
            <p>
              exploiter et améliorer le Service, y compris le personnaliser en
              fonction des préférences des utilisateurs;
            </p>
          </li>
          <li>
            <p>
              fournir des mises à jour sur les produits ou les services aux
              utilisateurs;
            </p>
          </li>
          <li>
            <p>
              envoyer des avis promotionnels, des offres ou d’autre matériel de
              marketing ciblé, et d’autres informations;
            </p>
          </li>
          <li>
            <p>
              répondre à vos questions, requêtes, commentaires et instructions;
            </p>
          </li>
          <li>
            <p>maintenir la sécurité et l’intégrité de nos systèmes;</p>
          </li>
          <li>
            <p>
              comprendre les préférences des consommateurs à l’échelle de
              nombreuses marques;
            </p>
          </li>
          <li>
            <p>maintenir de bonnes relations avec les clients;</p>
          </li>
          <li>
            <p>évaluer la performance et la sécurité des produits;</p>
          </li>
          <li>
            <p>
              se conformer aux politiques, aux procédures et aux exigences
              juridiques;
            </p>
          </li>
          <li>
            <p>
              améliorer nos produits et nos services, ainsi que d’autres fins
              commerciales.
            </p>
          </li>
        </ul>
        <br />
        <p>
          Les renseignements que vous fournissez en présentant une demande
          d’emploi ou de stage via notre Centre de carrières sont utilisés pour
          vous fournir de l’information sur les occasions d’emploi, pour
          administrer le processus d’embauche et étudier votre candidature.
          Lorsque c’est applicable, en combinaison avec les lois et les
          règlements appliqués par la Equal Employment Opportunity Commission
          (la “EEOC”), l’Office of Federal Contract Compliance Programs
          (l’”OFCCP”) et les organisations de réglementation étatiques et
          locales semblables, nous pourrions vous demander de nous fournir des
          renseignements personnellement identifiables (comme le statut d’ancien
          combattant, le sexe et l’ethnicité). La fourniture de renseignements
          personnellement identifiables est volontaire, mais si vous nous
          fournissez lesdits renseignements, nous pourrions les soumettre à
          l’EOC, à l’OFCCP et à des organisations de réglementation étatiques et
          locales semblables, ou les utiliser ou les divulguer autrement à des
          fins commerciales, notamment pour répondre à des demandes
          d’information, répondre à des exigences réglementaires en matière de
          production de rapports et nous défendre en cas de plaintes reliées à
          l’emploi.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Renseignements que vous divulguez publiquement ou à autrui
          </strong>
        </p>
        <p>
          Le Service pourrait vous permettre de publier ou de soumettre du CGU,
          notamment le consentement écrit, les profils d’utilisateur, les
          enregistrements audio ou visuels, les graphiques informatiques, les
          illustrations, les données ou d’autre contenu, y compris les
          Renseignements personnels. Si vous choisissez de soumettre du CGU dans
          une partie publique du Service, votre CGU sera considéré comme
          “public” et sera accessible à quiconque, y compris Henkel. Nonobstant
          toute disposition contraire, et sous réserve de la loi applicable, à
          moins d’entente différente explicite avec nous, les Renseignements
          personnels faisant partie du CGU ne sont pas assujettis aux
          limitations de l’utilisation ou du partage, ou aux autres obligations,
          de Henkel, relativement aux Renseignements personnels recueillis par
          Henkel ou aux autres Renseignements personnels en vertu du présent
          Déclaration de confidentialité ou autre, et pourraient être utilisés
          et partagés par Henkel et des tiers dans la pleine mesure permise par
          la loi applicable. Henkel vous encourage à faire preuve de prudence en
          prenant des décisions au sujet de ce que vous divulguez dans ces
          parties publiques. Pour en savoir davantage sur la façon dont le CGU
          est traité en vertu des Conditions d’utilisation du Service, cliquez{' '}
          <a
            href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            ici
          </a>{' '}
          [section 6 des Conditions d’utilisation].
        </p>
        <p>
          De plus, le Service pourrait vous donner la possibilité d’envoyer une
          communication à un ami ou à un autre contact. Dans ce cas, Henkel se
          fie sur vous pour envoyer des communications uniquement aux personnes
          qui vous ont donné la permission de le faire. Les Renseignements
          personnels que vous fournissez sur le destinataire (p. ex. son nom et
          son adresse courriel) seront utilisés pour faciliter la communication,
          mais ne seront pas utilisés par Henkel à d’autres fins de marketing,
          sauf si Henkel obtient le consentement de ladite personne. Votre nom
          complet, vos coordonnées et le message peuvent être inclus dans la
          communication. En ce qui concerne les résidents du Canada, vous
          pourriez uniquement nous fournir les coordonnées d’amis avec lesquels
          vous avez eu des communications directes, volontaires et mutuelles, et
          avec lesquels il est raisonnable de conclure que vous avez une
          relation personnelle en tenant compte des intérêts, des expériences et
          des opinions partagés, et d’autres facteurs pertinents. Vous pourriez
          fournir uniquement l’adresse courriel de membres de votre famille avec
          lesquels vous êtes lié par le mariage, une union de fait ou une
          relation parent-enfant, et avec lesquels vous avez eu des
          communications directes.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Enregistrement chronologique des données à l’aide de la technologie,
            témoins et techniques reliées
          </strong>
        </p>
        <p>
          Lorsque vous interagissez avec nos Services, votre navigateur ou votre
          appareil pourrait communiquer avec la technologie que nous utilisons
          dans le cadre de notre Service. Par exemple, pendant que vous utilisez
          notre Service, votre navigateur communique avec notre technologie, qui
          enregistre par la suite vos interactions et vos demandes de services
          et de contenu pour nous aider à gérer et à améliorer l’utilité de
          notre Service, et pour effectuer de la recherche et analyser son
          utilisation. Les types de Renseignements sur l’utilisation peuvent
          comprendre votre adresse de protocole Internet (adresse IP), votre
          type de navigateur, l’URL, les demandes effectuées, les pages
          visitées, les activités effectuées sur la page, le jour et l’heure de
          la visite et des renseignements techniques reliés sur l’utilisation.
        </p>
        <p>
          Des témoins et autres technologies de suivi développées maintenant et
          à l’avenir (les “Technologies de suivi”) pourraient être utilisés pour
          recueillir des renseignements sur les interactions avec le Service ou
          les courriels, y compris des renseignements sur votre comportement de
          navigation et d’achat, pour vous authentifier au Service, pour
          analyser comment le Service est utilisé, pour relier les
          renseignements à la façon dont vous utilisez le Service avec votre
          compte, et pour faciliter la personnalisation de nos services. Nous
          utilisons ces moyens technologiques, tout comme le font nos filiales,
          partenaires commerciaux et fournisseurs de services. Pour nous aider à
          mesurer l’activité du Service et fournir une meilleure expérience aux
          utilisateurs, nous pourrions permettre à nos fournisseurs de services
          ou à nos partenaires commerciaux de compiler des renseignements comme
          les renseignements indiqués plus haut à l’aide de Technologies de
          suivi. Nous pourrions aussi permettre à nos partenaires de publicité
          et de personnalisation tiers de recueillir et d’utiliser lesdits
          renseignements pour créer du contenu personnalisé et de la publicité
          appropriée (y compris pour des sociétés non affiliées avec nous) selon
          vos visites avec le temps de sites Web, d’applications et d’autres
          services en ligne appartenant ou non à Henkel. Vous pourriez voir
          lesdites publicités sur d’autres sites Web, applications et services
          en ligne. Lesdits renseignements pourraient aussi être utilisés pour
          évaluer nos campagnes de publicité en ligne et celles de tiers ou pour
          personnaliser des promotions et d’autres messages commerciaux à votre
          intention sur notre Service et d’autres sites Web, applications et
          services en ligne.
        </p>
        <p>
          Un témoin est un petit fichier texte stocké dans l’appareil d’un
          utilisateur, qui pourrait être un témoin temporaire ou un témoin
          traceur. Les témoins temporaires facilitent la navigation sur le
          Service et expirent lorsque vous fermez votre navigateur. Les témoins
          traceurs restent dans votre système plus longtemps et nous aident à
          comprendre comment vous utilisez le Service et comment améliorer
          l’expérience des utilisateurs. Les témoins pourraient demeurer sur
          votre disque dur pour une période prolongée. Si votre navigateur
          bloque ou supprime les témoins, certains types de témoins pourraient
          être supprimés ou bloqués et cela peut causer le non-fonctionnement de
          certaines caractéristiques et fonctionnalités du Service. Un témoin
          Flash (ou objet partagé localement) est un fichier de données qui
          pourrait être installé sur un appareil à l’aide de plugiciels d’Adobe
          Flash, pouvant être intégré ou téléchargé par vous sur votre appareil.
          Les témoins HTML5 peuvent être programmés à l’aide du stockage local
          HTML5. Les témoins Flash et les témoins HTML5 sont stockés localement
          sur votre appareil ailleurs que dans le navigateur et les paramètres
          du navigateur ne les contrôleront pas. Pour identifier certains types
          d’objets partagés localement sur votre appareil et ajuster vos
          paramètres, veuillez visiter :{' '}
          <a
            href="www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html
          </a>{' '}
          (en anglais seulement). Le Service pourrait associer certains ou tous
          ces types de témoins à vos appareils. D’autres types de Technologies
          de suivi pourraient comprendre les pixels espions (aussi appelés
          “connexions malignes”), les scripts intégrés, les technologies
          d’identification de l’emplacement, les empreintes digitales, les
          technologies de reconnaissance des appareils et les méthodes de suivi
          intégrées aux applications. Voir la section 11 pour connaître certains
          choix relativement auxdites activités.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Partage et stockage des données</strong>
        </p>
        <p>
          Henkel pourrait divulguer vos renseignements à des tiers dans une
          mesure correspondant au présent Déclaration de confidentialité ou à
          d’autres énoncés écrits faits par nous au moment de la collecte, et
          dans la mesure ou ladite divulgation n’est pas interdite par la loi
          applicable, notamment des façons suivantes :
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              Les agents, fournisseurs, consultants et autres fournisseurs de
              services de Henkel (collectivement appelés les “Fournisseurs de
              services”) pourraient avoir accès à vos renseignement, notamment
              aux Renseignements personnels recueillis par Henkel et à d’autres
              Renseignements personnels, à des Renseignements démographiques et
              à des Renseignements sur l’utilisation, en lien avec leur travail
              au nom de Henkel, à condition toutefois que Henkel n’autorise pas
              ses Fournisseurs de services à utiliser les Renseignements
              personnels recueillis par Henkel à vous envoyer directement des
              messages de marketing direct autres que ceux reliés à Henkel et
              aux filiales de Henkel sans votre consentement. Pour en savoir
              davantage sur les choix que les Fournisseurs de services peuvent
              vous offrir, consultez la section 11.
            </p>
          </li>
          <li>
            <p>
              Nous nous réservons le droit de divulguer vos Renseignements
              personnels recueillis par Henkel et d’autres Renseignements
              personnels si la loi l’exige, en cas de mandat de perquisition,
              d’assignation à comparaître, d’ordonnance judiciaire ou sur
              demande des autorités gouvernementales.
            </p>
          </li>
          <li>
            <p>
              Nous pourrions fournir des Renseignements personnels recueillis
              par Henkel et d’autres Renseignements personnels vous concernant à
              des tiers en lien avec la réorganisation, la fusion, la vente, la
              coentreprise, la cession, le transfert ou autre disposition de la
              totalité ou d’une partie de notre entreprise, de nos actifs ou de
              notre inventaire, y compris les activités associées à la faillite
              ou à d’autres procédures semblables.
            </p>
          </li>
          <li>
            <p>
              Henkel pourrait partager vos Renseignements personnels avec ses
              sociétés affiliées et ses filiales (les “Filiales”), et d’autres
              tiers, dont certains pourraient se situer à l’extérieur des
              États-Unis, à des fins de marketing et autres activités
              commerciales, sous réserve de certains droits des résidents de la
              Californie et du Connecticut [voir la section 12].
            </p>
          </li>
        </ul>
        <br />
        <p>
          Vos Renseignements personnels pourraient être stockés pour une durée
          raisonnable dans les bases de données de Henkel, dont certaines se
          situent à l’extérieur des États-Unis et du Canada, et seront
          automatiquement transférés dans ces bases de données aux fins de
          stockage et de maintenance. Le Service est basé aux États-Unis, vise
          les résidents des États-Unis et du Canada et pour les personnes à
          l’extérieur du Canada, les renseignements recueillis par Henkel et ses
          Fournisseurs de services à l’aide du Service sont régis par la loi des
          États-Unis. Si vous accédez au Service à partir de l’extérieur des
          États-Unis, les renseignements recueillis à l’aide du Service
          pourraient être transférés, traités, stockés et utilisés aux
          États-Unis. Les lois sur la protection des données des États-Unis
          pourraient différer de celles de votre pays de résidence et fournir un
          niveau inférieur de protection des consommateurs, et les
          renseignements transférés aux États-Unis pourraient être consultés par
          les gouvernements et les organisations d’application de la loi des
          États-Unis conformément aux lois des États-Unis. Votre utilisation du
          Service, ou la fourniture de tout renseignement à l’aide du Service,
          signifie que vous consentez au transfert, au traitement, à
          l’utilisation, au partage et au stockage de vos renseignements, y
          compris vos Renseignements personnels, aux États-Unis tel qu’établi
          dans le présent Déclaration de confidentialité.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Contenu de tiers, Services fournis par des tiers, Fonctionnalités
            liées aux médias sociaux, publicité et analytique
          </strong>
        </p>
        <p>
          Le Service pourrait comprendre des hyperliens vers ou en lien avec le
          Service (p. ex. des applications et des plugiciels), des sites Web,
          des emplacements, des plateformes, des applications ou des services
          exploités par des tiers (le(s) “Service(s) fournis par des tiers”).
          Lesdits Services fournis par des tiers peuvent utiliser leurs propres
          témoins, pixels espions et autres Technologies de suivi pour
          recueillir de façon indépendante des renseignements à votre sujet et
          pourraient solliciter des Renseignements personnels de votre part.
          Henkel n’est pas responsable des pratiques relatives à la
          confidentialité ou du contenu des Services fournis par des tiers.
          Notez que les déclaration de confidentialité applicables auxdits
          Services fournis par des tiers peuvent être très différents de
          l’Déclaration de confidentialité de Henkel, et nous vous avisons de
          les lire attentivement avant d’utiliser lesdits services. Vous
          convenez que Henkel ne peut être tenu responsable de toute action ou
          contenu desdits Services fournis par des tiers.
        </p>
        <p>
          Certaines fonctionnalités du Service permettent des interactions entre
          le Service et certains Services fournis par des tiers, comme les
          réseaux sociaux tiers (les “Fonctionnalités liées aux médias
          sociaux”). Les Fonctionnalités liées aux médias sociaux peuvent
          comprendre : la possibilité pour vous d’envoyer du contenu comme des
          contacts et des photographies entre le Service et un Service fourni
          par des tiers; cliquer “j’aime” ou “partager” du contenu de Henkel;
          ouvrir une session dans le Service à l’aide d’un compte de Service
          fourni par des tiers (p. ex. utiliser Facebook Connect pour ouvrir une
          session dans le Service); et connecter autrement le Service à un
          Service fourni par des tiers (p. ex. obtenir ou transmettre de
          l’information en provenance ou en destination du Service). Si vous
          utilisez les Fonctionnalités liées aux médias sociaux et
          potentiellement d’autres Services fournis par des tiers, les
          renseignements que vous publiez ou auxquelles vous donnez accès
          pourraient être affichés publiquement sur le Service (voir la section
          5) ou par le Service fourni par des tiers que vous utilisez. De même,
          si vous publiez des renseignements sur un service fourni par des tiers
          qui fait référence au Service (p. ex. en utilisant un mot-clic associé
          à Henkel ou à un autre Affilié de Henkel dans un gazouillis ou une
          mise à jour de statut), vous acceptez que votre publication puisse
          être utilisée sur le Service, en lien avec le Service ou autrement par
          Henkel ou d’autres Affiliés de Henkel. De plus, Henkel et le tiers
          pourraient avoir accès à certains renseignements sur vous et sur votre
          utilisation du Service et de tout Service fourni par des tiers.
        </p>
        <p>
          Henkel pourrait interagir et travailler avec des Fournisseurs de
          services et d’autres tiers pour offrir de la publicité sur le Service
          et sur d’autres services fournis par des tiers. Certaines de ces
          publicités pourraient être personnalisées selon vos intérêts en
          fonction de notre navigation dans le Service et ailleurs sur Internet,
          ce qu’on appelle parfois la “publicité ciblée par centres d’intérêt”
          et la “publicité comportementale en ligne” (la “Publicité ciblée par
          centres d’intérêt), qui pourrait comprendre l’envoi de publicités sur
          un Service fourni par des tiers à votre intention après que vous ayez
          quitté le Service (c.-à-d. le “ciblage publicitaire”). Par exemple, le
          Service pourrait employer un “Témoin d’identification DoubleClick” qui
          pourrait attribuer un identifiant pseudonymisé pour, entre autres,
          effectuer le suivi de la publicité DoubleClick. DoubleClick est un
          service fourni par Google. Pour en savoir davantage sur votre capacité
          de vous retirer de la Publicité ciblée par centres d’intérêt,
          consultez la section 11 ci-dessous.
        </p>
        <p>
          Henkel pourrait faire appel à Google Analytics, à Adobe Analytics ou à
          d’autres Fournisseurs de services pour l’obtention de services
          d’analytique. Lesdits services d’analytique pourraient faire appel à
          des témoins et à d’autres Technologies de suivi pour aider Henkel à
          analyser les utilisateurs du Service et leur façon d’utiliser le
          Service. Les renseignements générés par lesdits services (p. ex. votre
          adresse IP et d’autres Renseignements sur l’utilisation) pourraient
          être transmis auxdits Fournisseurs de services et stockés par ceux-ci
          sur des serveurs aux États-Unis (ou ailleurs) et lesdits Fournisseurs
          de services pourraient utiliser lesdits renseignements à des fins
          comme l’évaluation de votre utilisation du Service, la compilation de
          rapports statistiques sur l’activité du Service, et la fourniture
          d’autres services reliés à l’activité du Service et à d’autres
          utilisations d’Internet.
        </p>
        <p>
          Sauf dans la mesure où nous combinons les renseignements que nous
          recevons des Fournisseurs de services, des Services fournis par des
          tiers ou d’autres tiers à des Renseignements personnels recueillis par
          Henkel, auquel cas Henkel traitera les renseignements combinés comme
          des Renseignements personnels recueillis par Henkel en vertu du
          présent Déclaration de confidentialité, les données obtenues par
          Henkel d’un tiers, même en association avec le Service, ne sont pas
          assujetties aux limitations de Henkel concernant les Renseignements
          personnels recueillis par Henkel en vertu du présent Déclaration de
          confidentialité, mais lesdites données demeurent assujetties aux
          restrictions imposées à Henkel par le tiers, le cas échéant. Sinon,
          les renseignements recueillis, stockés et partagés par des tiers
          demeurent assujettis à leurs politiques et à leurs pratiques de
          confidentialité, y compris s’ils continuent de partager des
          renseignements avec Henkel, les types de renseignements partagés et
          vos choix concernant ce qui est visible par les autres sur les
          Services fournis par des tiers.
        </p>
        <br />
        <p>
          Henkel n’est pas responsable des politiques ou des pratiques
          commerciales des tiers et ne donne aucune représentation à leur sujet,
          notamment les Fournisseurs de services d’analytique et les Services
          fournis par des tiers associés au Service, et vous encourage à
          consulter leurs politiques de confidentialité et leurs conditions
          d’utilisation. Voir la section 11 pour en savoir davantage sur
          certains choix offerts par certains tiers concernant leur collecte et
          leur utilisation des données, y compris la Publicité ciblée par
          centres d’intérêt et l’analytique.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Sécurité et surveillance</strong>
        </p>
        <p>
          Henkel prendra des précautions raisonnables pour protéger vos
          Renseignements personnels (à l’exception du CGU public) des pertes,
          mauvaises utilisations ou altérations. Les Renseignements personnels
          pourraient être consultables par des personnes appartenant à notre
          organisation, ou par des fournisseurs de services tiers, qui ont
          besoin de les consulter aux fins susmentionnées, ou à d’autres fins
          permises ou exigées par la loi applicable. Gardez à l’esprit,
          toutefois, que tout courriel ou autre transmission par Internet ne
          peut être complètement protégé des interceptions non autorisées et que
          l’Internet et le stockage numérique en ligne ne sont pas complètement
          sécurisés, et nous ne garantissons pas la sécurité des renseignements
          vous concernant recueillis à l’aide du Service.
        </p>
        <p>
          Pour favoriser votre protection et celle des autres, nous et nos
          fournisseurs de services pourrions (sans nous y engager) surveiller
          l’utilisation du Service, et nous pourrions recueillir et utiliser des
          renseignements reliés, y compris les Renseignements personnels
          recueillis par Henkel et d’autres Renseignements personnels à toute
          fin non interdite par la loi applicable ou contraire au présent
          Déclaration de confidentialité, notamment pour identifier des
          activités et des transactions frauduleuses; prévenir les abus, faire
          enquête et intenter des poursuites pour toute menace ou mauvaise
          utilisation potentielle du Service; assurer la conformité avec les{' '}
          <a
            href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Conditions d’utilisation
          </a>{' '}
          et le présent Déclaration de confidentialité; faire enquête sur les
          violations ou appliquer les présentes ententes; et autrement protéger
          les droits et la propriété de Henkel, de nos tiers affiliés et
          d’autres utilisateurs. La surveillance peut comprendre la collecte,
          l’enregistrement et l’analyse d’activités ou de communications en
          ligne à l’aide de notre Service. Si vous ne consentez pas auxdites
          conditions, vous devez cesser d’utiliser le Service.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Enfants</strong>
        </p>
        <p>
          Le Service vise un public général et n’est pas destiné aux enfants de
          moins de 13 ans. Henkel n’a pas l’intention de recueillir des
          renseignements personnels, tels que définis par la U.S. Children’s
          Online Privacy Protection Act (la “COPPA”) (les “Renseignements
          personnels concernant des enfants”) d’une façon qui n’est pas permise
          par la COPPA. Si nous apprenons que nous avons recueilli des
          Renseignements personnels concernant des enfants d’une façon non
          permise par la COPPA ou une autre loi applicable, nous supprimerons
          lesdites données dans la mesure requise par la COPPA ou toute autre
          loi applicable.
        </p>
        <p>
          Tout résident de la Californie âgé de moins de dix-huit (18) ans qui
          s’est inscrit pour utiliser le Service et qui a publié du contenu ou
          des renseignements sur le Service peut demander d’être retiré en
          communiquant avec Henkel{' '}
          <a
            href="https://www.henkel-northamerica.com/contact-us"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            ici
          </a>{' '}
          en donnant des détails sur l’emplacement du contenu ou des
          renseignements publiés et en attestant qu’il les a publiés. Henkel
          exercera les efforts raisonnables de bonne foi pour retirer la
          publication de la vue potentielle du public ou pour les anonymiser de
          façon à ce que le mineur ne puisse pas être identifié dans la mesure
          requise par la loi applicable. Ledit processus de retrait ne peut
          garantir un retrait complet ou exhaustif. Par exemple, des tiers
          pourraient avoir republié ou archivé du contenu à l’aide de moteurs de
          recherche et autres que Henkel ne contrôle pas.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Vos choix concernant vos Renseignements personnels</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Généralités sur les Technologies de suivi</strong>
            </p>
            <p>
              Les témoins réguliers peuvent généralement être désactivés ou
              retirés à l’aide des outils disponibles dans la plupart des
              navigateurs commerciaux, et dans certains cas bloqués dans le
              futur en sélectionnant certains paramètres. Les navigateurs
              offrent différentes fonctionnalités et options, donc vous devrez
              peut-être les configurer séparément. De plus, les outils des
              navigateurs commerciaux pourraient ne pas être efficaces pour les
              témoins Flash (aussi appelé objet partagé localement), les témoins
              HTML5 ou d’autres Technologies de suivi. Pour en savoir davantage
              sur la désactivation des témoins Flash, rendez-vous au site Web
              d’Adobe :{' '}
              <a
                href="helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html
              </a>{' '}
              (en anglais seulement). Sachez que si vous désactivez ou retirez
              lesdites technologies, certaines parties du Service pourraient ne
              pas fonctionner et que lorsque vous revisiterez le Service, votre
              capacité de limiter les Technologies de suivi basées sur le
              navigateur est sujette aux paramètres et aux limitations de votre
              navigateur.
            </p>
            <p>
              Certaines Technologies de suivi reliées aux applications, en lien
              avec l’utilisation non reliée à un navigateur (p. ex. la plupart
              des fonctionnalités d’une application mobile) peuvent uniquement
              être désactivées en désinstallant l’application. Pour désinstaller
              une application, suivez les instructions de votre système
              d’exploitation ou du fabricant de votre appareil.
            </p>
            <p>
              Les paramètres de votre navigateur pourraient vous permettre de
              transmettre automatiquement un signal d’interdiction de suivi aux
              services en ligne que vous visitez. Notez toutefois qu’il n’y a
              pas de consensus parmi les participants de l’industrie sur ce que
              signifie une interdiction de suivi dans ce contexte. Comme
              beaucoup de services en ligne, Henkel ne modifie pas les pratiques
              de Henkel lorsque Henkel reçoit un signal d’interdiction de suivi
              du navigateur d’un visiteur. Pour en savoir davantage sur
              l’interdiction de suivi, vous pouvez visiter{' '}
              <a
                href="http://www.allaboutdnt.com"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.allaboutdnt.com
              </a>{' '}
              (en anglais seulement), mais nous ne sommes pas responsables de
              l’exhaustivité ou de l’exactitude de cette information fournie par
              un tiers. Toutefois, certains tiers pourraient vos donner des
              choix quant à leurs Technologies de suivi. Une façon d’identifier
              potentiellement les témoins sur notre Site est d’ajouter le
              plugiciel gratuit Ghostery à votre navigateur (<a
                href="www.ghostery.com/fr/"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                www.ghostery.com/fr/
              </a>), qui, selon Ghostery, affichera pour vous les témoins
              traditionnels des navigateurs associés aux sites Web (mais pas aux
              applications mobiles) que vous visitez et les politiques et
              options de confidentialité et de refus des parties exploitant
              lesdits témoins. Henkel n’est pas responsable de l’exhaustivité ou
              de l’exactitude dudit outil ou des avis ou mécanismes de choix des
              tiers. Pour de l’information plus précise sur certaines des
              options offertes par les fournisseurs de services d’analytique et
              de publicité tiers, consultez la prochaine section.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>
                Technologies de suivi aux fins d’analytique et de publicité
              </strong>
            </p>
            <p>
              Vous pourriez avoir des choix concernant l’utilisation de témoins
              de Google Analytics en vous rendant à{' '}
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                https://tools.google.com/dlpage/gaoptout
              </a>{' '}
              ou en téléchargeant l’extension de refus de navigateur de Google
              Analytics. Vous pourriez avoir des choix concernant l’utilisation
              de témoins d’Adobe Analytics en vous rendant à{' '}
              <a
                href="https://www.adobe.com/ca_fr/privacy/opt-out.html"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.adobe.com/ca_fr/privacy/opt-out.html
              </a>{' '}
              à la section portant sur le refus des clients de mesurer leur
              utilisation de leurs sites Web ou de personnaliser la publicité
              pour eux. Vous pourriez avoir des choix concernant l’utilisation
              de témoins de Google DoubleClick en vous rendant à{' '}
              <a
                href="www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew
              </a>{' '}
              (en anglais seulement). Henkel n’est pas responsable de
              l’efficacité ou de la conformité de toute option ou de tout
              programme de refus de tiers ou de l’exactitude de leurs énoncés
              concernant lesdits programmes.
            </p>
            <p>
              Vous pouvez choisir de recevoir certaines Publicités ciblées par
              centres d’intérêt en soumettant des refus aux programmes de
              l’industrie. Certains des annonceurs et des fournisseurs de
              service qui offrent des services liés à la publicité pour nous et
              des tiers pourraient participer au Digital Advertising Alliance’s
              (la “DAA”) Self-Regulatory Program for Online Behavioral
              Advertising. Pour en savoir davantage sur la façon d’exercer
              certains choix concernant la Publicité ciblée par centres
              d’intérêt, visitez{' '}
              <a
                href="http://www.aboutads.info/choices"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.aboutads.info/choices
              </a>{' '}
              (en anglais seulement) et{' '}
              <a
                href="http://www.aboutads.info/appchoices"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.aboutads.info/appchoices
              </a>{' '}
              (en anglais seulement) pour en savoir davantage sur le programme
              de rejet de la DAA. Certaines de ces sociétés pourraient aussi
              être membres de la Network Advertising Initiative (la “NAI”). Pour
              en savoir davantage sur la NAI et sur vos options de refus pour
              les membres, visitez{' '}
              <a
                href="http://www.networkadvertising.org/choices/"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.networkadvertising.org/choices/
              </a>{' '}
              (en anglais seulement). Sachez que, même si vous êtes en mesure de
              refuser certains types de Publicité ciblée par centres d’intérêt,
              vous pourriez continuer de recevoir d’autres types de publicité.
              Le refus signifie seulement que les membres sélectionnés ne
              devraient plus vous envoyer de la Publicité ciblée par centres
              d’intérêt, mais cela ne signifie pas que vous ne recevrez plus de
              contenu ou de publicités ciblées (p. ex. d’autres réseaux
              publicitaires). Certaines sociétés donnent aussi une occasion
              précise de refuser. Pour en savoir davantage sur les choix en
              matière de Publicité ciblée par centres d’intérêt offerts par
              DoubleClick, cliquez{' '}
              <a
                href="https://www.google.com/settings/u/0/ads/plugin?hl=en&sig=ACi0TCigvVYAN17ugYRMwQf_InKv4i5GKLPNen5UUD8qFqiWU4vtXR5jsz_uaOHdJqvhufEjezDh-Q13icRRRab9WJDGpQbwkQ"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                ici
              </a>. De plus, si vos navigateurs sont configurés pour refuser les
              témoins lorsque vous visitez ces pages Web de refus, ou si vous
              effacez plus tard vos témoins, utilisez un appareil ou un
              navigateur Web différent ou utilisez une méthode d’accès non basée
              sur un navigateur (p. ex. une application mobile), votre refus
              basé sur les navigateurs pourrait ne pas ou ne plus être efficace.
              Henkel appuie les{' '}
              <a
                href="www.iab.net/media/file/ven-principles-07-01-09.pdf"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                2009 Self-regulatory Principles for Online Behavioral
                Advertising
              </a>{' '}
              et s’attend à ce que les réseaux publicitaires avec lesquels
              Henkel collabore directement pour vous offrir de la Publicité
              ciblée par centres d’intérêt le fassent aussi, même si Henkel ne
              peut pas garantir leur conformité. Henkel n’est pas responsable de
              l’efficacité ou de la conformité de toute option ou programme de
              refus de tiers ou de l’exactitude de leurs énoncés concernant
              lesdits programmes.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Applications mobiles</strong>
            </p>
            <p>
              En ce qui concerne les applications mobiles de Henkel (les
              “applications”), vous pouvez faire cesser toute la collecte de
              données générée par l’utilisation de l’application en
              désinstallant l’application. De plus, vous pourriez être en mesure
              d’exercer des choix précis en matière de confidentialité, comme
              l’activation ou la désactivation de certaines fonctionnalités (p.
              ex. les services géodépendants, les notifications poussées,
              l’accès aux calendriers/contacts/photos, etc.) en ajustant les
              permissions des paramètres de votre appareil mobile ou de votre
              application. Sachez que si les services de localisation précise
              par GPS sont désactivés, d’autres moyens d’établir ou d’estimer
              l’emplacement (p. ex. la connexion ou la proximité au Wi-Fi, la
              technologie Bluetooth, les pixels espions ou nos réseaux)
              pourraient persister. Consultez aussi la section précédente
              concernant les choix en matière de Publicité mobile ciblée par
              centres d’intérêt de la DAA.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Communications</strong>
            </p>
            <p>
              Vous pouvez refuser de recevoir certaines communications
              promotionnelles (courriels ou textos) de Henkel en tout temps des
              façons suivantes : i) pour ne plus recevoir de courriels
              promotionnels, suivez les instructions fournies dans les courriels
              afin de cliquer sur le lien de désabonnement ou, si disponible, en
              modifiant vos préférences de communication en ouvrant une session
              dans votre compte; ii) pour ne plus recevoir de textos, suivez les
              instructions fournies dans les textos de Henkel en textant le mot
              “STOP”; iii) pour ne plus recevoir de notifications poussées,
              désactivez les notifications poussées dans les paramètres de votre
              appareil ou de l’application, le cas échéant. Notez que votre
              refus est limité à l’adresse courriel ou au numéro de téléphone
              utilisé et n’affectera pas les abonnements ultérieurs. Si vous
              choisissez de refuser uniquement certaines communications,
              d’autres communications pourraient se poursuivre. Même si vous
              choisissez de refuser de recevoir des communications
              promotionnelles, Henkel pourrait, sous réserve de la loi
              applicable, continuer de vous envoyer des communications non
              promotionnelles, comme celles qui concernent votre compte, vos
              transactions, vos services ou nos relations commerciales
              continues.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Centre de carrières</strong>
            </p>
            <p>
              Si vous avez créé un curriculum vitæ à l’aide de notre Centre de
              carrières, vous pouvez consulter, réviser, corriger, mettre à
              jour, modifier ou supprimer les renseignements de votre profil ou
              votre curriculum vitæ en tout temps. Connectez-vous simplement à
              votre compte, allez à votre profil ou à votre curriculum vitæ, et
              apportez les modifications nécessaires. Vous pouvez supprimer
              votre curriculum vitæ de notre base de données en ligne en tout
              temps en accédant à votre compte; sachez toutefois que nous nous
              réservons le droit de conserver une copie a) tel qu’exigé par la
              loi applicable; et b) pour aussi longtemps qu’il est
              raisonnablement nécessaire aux fins de tenue de dossiers, sauf
              dans la mesure interdite par la loi applicable.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Droits de confidentialité des résidents de la Californie et du
            Connecticut
          </strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Droits des résidents de la Californie : Henkel fournit aux
              résidents de la Californie l’option d’accepter ou de refuser le
              partage de “renseignements personnels”, tel que défini dans la loi
              “Shine the Light” avec des tiers, autres que les Affiliés de
              Henkel, aux fins de marketing direct des tiers. Les résidents de
              la Californie peuvent choisir l’option de refus ou demander de
              l’information au sujet de la conformité de Henkel à la loi Shine
              the Light, et obtenir la divulgation des tiers avec lesquels
              Henkel a partagé des renseignements, conformément à la loi sur le
              marketing direct, à défaut de votre choix et des catégories de
              renseignements partagés, en communiquant avec Henkel{' '}
              <a
                href="mailto:PrivacyNA@henkel.com"
                style={{ textDecoration: 'underline' }}
              >
                ici
              </a>{' '}
              ou en envoyant une lettre à Henkel à :
            </p>
            <p>
              Attention : Henkel Privacy Inquiries
              <br />
              Communications Department
              <br />
              Henkel Corporation
              <br />
              One Henkel Way
              <br />
              Rocky Hill, CT 06067
            </p>
            <p>
              La première ligne de la description de la demande doit comprendre
              “California Privacy Rights Request” et indiquer votre nom, votre
              adresse municipale, votre ville, votre État et votre code ZIP.
              Notez que Henkel ne doit répondre qu’à une seule demande par
              client par année, et que Henkel n’est pas tenue de répondre aux
              demandes effectuées autrement que par l’adresse courriel ou
              l’adresse postale fournies.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Droits des résidents du Connecticut : La loi du Connecticut exige
              que toute personne ou entité qui recueille des numéros d’assurance
              sociale de résidents du Connecticut dans le cadre de leurs
              activités crée une politique de protection de la confidentialité
              et la publie ou l’affiche publiquement. Notre politique est de
              protéger la confidentialité des numéros d’assurance sociale en
              notre possession de la mauvaise utilisation et de la divulgation
              inadéquate en maintenant et en appliquant des politiques et des
              mesures de protection physique et électronique contre la mauvaise
              utilisation et la divulgation inadéquate. La divulgation illégale
              de numéros d’assurance sociale est interdite, et l’accès aux
              numéros d’assurance sociale est limité au personnel qui a besoin
              d’accéder auxdits renseignements pour effectuer leurs fonctions
              professionnelles.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Déclaration de confidentialité pour les applications mobiles
          </strong>
        </p>
        <p>
          Henkel a développé certaines applications mobiles que vous pouvez
          télécharger dans votre appareil mobile. Lorsque vous téléchargez une
          application mobile, vous pourriez avoir l’occasion de nous fournir des
          renseignements vous concernant, comme vos coordonnées, vos préférences
          en matière de produits, des photographies ou d’autres renseignements.
          De plus, nous pourrions obtenir des renseignements au sujet de
          l’appareil mobile, comme l’identifiant et le système d’exploitation de
          l’appareil, et l’utilisation de l’appareil. Les renseignements obtenus
          à l’aide d’une application mobile seront utilisés conformément au
          présent Déclaration de confidentialité et pourraient être assujettis à
          des modalités supplémentaires publiées dans l’application mobile.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Consultation et modification des renseignements</strong>
        </p>
        <p>
          Henkel pourrait fournir des pages Web ou d’autres mécanismes vous
          permettant de supprimer, de corriger ou de mettre à jour certains des
          Renseignements personnels recueillis par Henkel, et possiblement
          certains autres renseignements à votre sujet (p. ex. renseignements
          sur votre profil et votre compte). Vous pourriez aussi demander
          d’accéder à vos Renseignements personnels et demander qu’ils soient
          corrigés si vous croyez qu’ils sont inexacts à l’aide des coordonnées
          fournies plus bas. Nous pourrions exiger de vérifier votre identité
          avant de vous permettre d’accéder aux renseignements. Henkel exercera
          des efforts de bonne foi pour apporter les modifications demandées
          dans les bases de données de Henkel en service aussitôt que possible,
          mais il n’est pas toujours possible de modifier, d’enlever ou de
          supprimer complètement tous vos renseignements ou toutes vos
          publications publiques des bases de données de Henkel. De plus, nous
          nous réservons le droit de conserver des données a) tel qu’exigé par
          la loi applicable; et b) pour aussi longtemps qu’il est
          raisonnablement nécessaire de le faire, sauf dans la mesure interdite
          par la loi applicable.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Questions</strong>
        </p>
        <p>
          Veuillez nous envoyer vos questions ou commentaires concernant nos
          pratiques de confidentialité en nous envoyant un courriel à{' '}
          <a
            href="mailto:PrivacyNA@henkel.com"
            style={{ textDecoration: 'underline' }}
          >
            PrivacyNA@henkel.com
          </a>, ou une lettre au :
        </p>
        <p>
          Henkel Privacy Inquiries
          <br />
          Compliance Officer
          <br />
          Henkel Corporation
          <br />
          One Henkel Way
          <br />
          Rocky Hill, CT 06067
        </p>
      </li>
    </ol>
  </div>
);

export default TermsPrivacyFr;



// WEBPACK FOOTER //
// ./src/components/_Site/CA/TermsPrivacyFr.js